var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _symbol92, _symbol93, _symbol94, _symbol95, _symbol96, _symbol97, _symbol98, _symbol99, _symbol100, _symbol101, _symbol102, _symbol103, _symbol104, _symbol105, _symbol106, _symbol107, _symbol108, _symbol109, _symbol110, _symbol111, _symbol112, _symbol113, _symbol114, _symbol115, _symbol116, _symbol117, _symbol118, _symbol119, _symbol120, _symbol121, _symbol122, _path, _path2, _symbol123, _symbol124, _symbol125, _symbol126, _symbol127, _symbol128, _symbol129, _symbol130, _symbol131;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "cloud",
    viewBox: "0 0 18 12",
    fill: "#C5D2FF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 10.028C8.04906 10.8133 6.82963 11.2852 5.5 11.2852C2.46243 11.2852 0 8.82272 0 5.78516C0 2.74759 2.46243 0.285156 5.5 0.285156C6.82963 0.285156 8.04906 0.756974 9 1.54232C9.95094 0.756974 11.1704 0.285156 12.5 0.285156C15.5376 0.285156 18 2.74759 18 5.78516C18 8.82272 15.5376 11.2852 12.5 11.2852C11.1704 11.2852 9.95094 10.8133 9 10.028Z",
    fill: "url(#paint0_radial_946_17410)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_946_17410",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0112 6.76192) rotate(93.8) scale(13.168 21.6502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29142,
    stopColor: "#C5D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82B5FF"
  }))))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "logo",
    viewBox: "0 0 109 20",
    fill: "#C5D2FF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.5359 17.2872C90.8737 18.6317 88.7573 19.437 86.4529 19.437C81.1071 19.437 76.7734 15.1034 76.7734 9.75757C76.7734 4.41176 81.1071 0.078125 86.4529 0.078125C88.7573 0.078125 90.8737 0.883427 92.5359 2.22797C94.1981 0.883427 96.3144 0.078125 98.6189 0.078125C103.965 0.078125 108.298 4.41176 108.298 9.75757C108.298 15.1034 103.965 19.437 98.6189 19.437C96.3144 19.437 94.1981 18.6317 92.5359 17.2872Z",
    fill: "url(#paint0_radial_946_7230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4104 16.5578C82.3302 16.5578 79.4531 13.6807 79.4531 9.75743C79.4531 5.83412 82.3302 2.95703 86.4104 2.95703C90.4907 2.95703 93.3155 5.83412 93.3155 9.75743V10.856H82.7225C83.141 12.7391 84.5796 13.733 86.4104 13.733C87.7967 13.733 88.8167 13.3407 89.4706 12.5037H92.7924C91.8246 14.9623 89.4706 16.5578 86.4104 16.5578ZM82.801 8.37119H90.0199C89.5229 6.64494 88.1105 5.78181 86.4104 5.78181C84.658 5.78181 83.298 6.67109 82.801 8.37119Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3778 16.5578C70.0822 16.5578 68.016 14.8054 67.9375 12.3991H71.0761C71.1023 13.2622 71.8608 13.8377 73.3778 13.8377C74.9733 13.8377 75.6533 13.1838 75.6533 12.3991C75.6533 11.4052 74.5025 11.2744 73.1163 11.0914C71.1285 10.8298 68.199 10.4898 68.199 7.32498C68.199 4.68329 70.213 2.95703 73.3255 2.95703C76.4903 2.95703 78.4258 4.7356 78.5043 7.01111H75.4179C75.3395 6.22645 74.6071 5.67719 73.3778 5.67719C72.0177 5.67719 71.3377 6.33107 71.3377 7.08958C71.3377 8.08348 72.5147 8.24042 73.9009 8.4235C75.6272 8.6589 78.792 8.99892 78.792 12.216C78.792 14.8316 76.6734 16.5578 73.3778 16.5578Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3128 16.5578C56.2326 16.5578 53.3555 13.6807 53.3555 9.75743C53.3555 5.83412 56.2326 2.95703 60.3128 2.95703C64.393 2.95703 67.2701 5.83412 67.2701 9.75743C67.2701 13.6807 64.393 16.5578 60.3128 16.5578ZM60.3128 13.6546C62.5883 13.6546 64.1053 12.0329 64.1053 9.75743C64.1053 7.48191 62.5883 5.86028 60.3128 5.86028C58.0373 5.86028 56.4941 7.48191 56.4941 9.75743C56.4941 12.0329 58.0373 13.6546 60.3128 13.6546Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.749 16.2178V8.71121C41.749 4.81406 44.0507 2.95703 47.4247 2.95703C50.7988 2.95703 53.0743 4.81406 53.0743 8.76352V8.84199H49.988V8.71121C49.988 6.61878 48.9417 5.86028 47.4247 5.86028C45.9077 5.86028 44.8615 6.61878 44.8615 8.71121V16.2178H41.749Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6273 16.5578C29.547 16.5578 26.6699 13.6807 26.6699 9.75743C26.6699 5.83412 29.547 2.95703 33.6273 2.95703C37.7075 2.95703 40.5846 5.83412 40.5846 9.75743C40.5846 13.6807 37.7075 16.5578 33.6273 16.5578ZM33.6273 13.6546C35.9028 13.6546 37.4198 12.0329 37.4198 9.75743C37.4198 7.48191 35.9028 5.86028 33.6273 5.86028C31.3517 5.86028 29.8086 7.48191 29.8086 9.75743C29.8086 12.0329 31.3517 13.6546 33.6273 13.6546Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7393 16.2178V9.49588C12.7393 5.18024 15.3025 2.95703 19.1212 2.95703C22.9399 2.95703 25.5031 5.15408 25.5031 9.49588V16.2178H22.3906V9.49588C22.3906 7.03727 21.0828 5.86028 19.1212 5.86028C17.1595 5.86028 15.8517 7.03727 15.8517 9.49588V16.2178H12.7393Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14051 16.5578C2.84494 16.5578 0.778661 14.8054 0.700195 12.3991H3.83884C3.865 13.2622 4.6235 13.8377 6.14051 13.8377C7.73599 13.8377 8.41603 13.1838 8.41603 12.3991C8.41603 11.4052 7.26519 11.2744 5.87896 11.0914C3.89115 10.8298 0.961749 10.4898 0.961749 7.32498C0.961749 4.68329 2.97571 2.95703 6.0882 2.95703C9.253 2.95703 11.1885 4.7356 11.267 7.01111H8.18063C8.10217 6.22645 7.36982 5.67719 6.14051 5.67719C4.78043 5.67719 4.10039 6.33107 4.10039 7.08958C4.10039 8.08348 5.27739 8.24042 6.66362 8.4235C8.38987 8.6589 11.5547 8.99892 11.5547 12.216C11.5547 14.8316 9.43609 16.5578 6.14051 16.5578Z",
    fill: "#00368E"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "about-logo",
    viewBox: "0 0 221 25",
    fill: "#C5D2FF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.103 22.4453C200.11 24.0429 197.572 24.9998 194.809 24.9998C188.401 24.9998 183.205 19.8511 183.205 13.4999C183.205 7.14868 188.401 2 194.809 2C197.572 2 200.11 2.95687 202.103 4.55445C204.095 2.95687 206.633 2 209.396 2C215.805 2 221 7.14868 221 13.4999C221 19.8511 215.805 24.9998 209.396 24.9998C206.633 24.9998 204.095 24.0429 202.103 22.4453Z",
    fill: "url(#paint0_radial_3579_10533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.759 21.5806C189.867 21.5806 186.418 18.1624 186.418 13.5013C186.418 8.84008 189.867 5.42188 194.759 5.42188C199.651 5.42188 203.037 8.84008 203.037 13.5013V14.8064H190.338C190.839 17.0438 192.564 18.2246 194.759 18.2246C196.421 18.2246 197.644 17.7585 198.428 16.7641H202.41C201.25 19.6851 198.428 21.5806 194.759 21.5806ZM190.432 11.8543H199.086C198.49 9.80339 196.797 8.77792 194.759 8.77792C192.658 8.77792 191.027 9.83446 190.432 11.8543Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.135 21.5806C175.184 21.5806 172.706 19.4986 172.612 16.6398H176.375C176.406 17.6652 177.316 18.3489 179.135 18.3489C181.047 18.3489 181.863 17.572 181.863 16.6398C181.863 15.459 180.483 15.3036 178.821 15.0861C176.438 14.7753 172.926 14.3713 172.926 10.6113C172.926 7.47279 175.34 5.42188 179.072 5.42188C182.866 5.42188 185.186 7.53494 185.28 10.2384H181.58C181.486 9.30619 180.608 8.65363 179.135 8.65363C177.504 8.65363 176.689 9.43049 176.689 10.3317C176.689 11.5125 178.1 11.6989 179.762 11.9165C181.831 12.1961 185.625 12.6001 185.625 16.4223C185.625 19.5297 183.086 21.5806 179.135 21.5806Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.47 21.5806C158.578 21.5806 155.129 18.1624 155.129 13.5013C155.129 8.84008 158.578 5.42188 163.47 5.42188C168.362 5.42188 171.811 8.84008 171.811 13.5013C171.811 18.1624 168.362 21.5806 163.47 21.5806ZM163.47 18.1314C166.198 18.1314 168.017 16.2047 168.017 13.5013C168.017 10.7978 166.198 8.87115 163.47 8.87115C160.742 8.87115 158.892 10.7978 158.892 13.5013C158.892 16.2047 160.742 18.1314 163.47 18.1314Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.214 21.1767V12.2583C141.214 7.62817 143.973 5.42188 148.018 5.42188C152.063 5.42188 154.791 7.62817 154.791 12.3204V12.4136H151.091V12.2583C151.091 9.77231 149.837 8.87115 148.018 8.87115C146.2 8.87115 144.945 9.77231 144.945 12.2583V21.1767H141.214Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.476 21.5806C126.584 21.5806 123.135 18.1624 123.135 13.5013C123.135 8.84008 126.584 5.42188 131.476 5.42188C136.367 5.42188 139.817 8.84008 139.817 13.5013C139.817 18.1624 136.367 21.5806 131.476 21.5806ZM131.476 18.1314C134.204 18.1314 136.022 16.2047 136.022 13.5013C136.022 10.7978 134.204 8.87115 131.476 8.87115C128.748 8.87115 126.898 10.7978 126.898 13.5013C126.898 16.2047 128.748 18.1314 131.476 18.1314Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.435 21.1767V13.1905C106.435 8.06321 109.508 5.42188 114.086 5.42188C118.664 5.42188 121.737 8.03214 121.737 13.1905V21.1767H118.005V13.1905C118.005 10.2695 116.437 8.87115 114.086 8.87115C111.734 8.87115 110.166 10.2695 110.166 13.1905V21.1767H106.435Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5222 21.5806C94.5713 21.5806 92.0941 19.4986 92 16.6398H95.7628C95.7942 17.6652 96.7035 18.3489 98.5222 18.3489C100.435 18.3489 101.25 17.572 101.25 16.6398C101.25 15.459 99.8706 15.3036 98.2087 15.0861C95.8255 14.7753 92.3136 14.3713 92.3136 10.6113C92.3136 7.47279 94.7281 5.42188 98.4595 5.42188C102.254 5.42188 104.574 7.53494 104.668 10.2384H100.968C100.874 9.30619 99.996 8.65363 98.5222 8.65363C96.8917 8.65363 96.0764 9.43049 96.0764 10.3317C96.0764 11.5125 97.4875 11.6989 99.1494 11.9165C101.219 12.1961 105.013 12.6001 105.013 16.4223C105.013 19.5297 102.473 21.5806 98.5222 21.5806Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.497 15.2113V15.6013C82.497 19.7113 80.037 21.6912 76.437 21.6912C72.837 21.6912 70.377 19.7113 70.377 15.6013V1.53125H73.947V6.48125H81.597V9.72125H73.947V15.6013C73.947 17.5813 74.967 18.3613 76.437 18.3613C77.907 18.3613 78.927 17.6113 78.927 15.6013V15.2113H82.497Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3688 14.1905V6.48047H67.9388V14.1905C67.9388 19.1405 64.9988 21.6905 60.6188 21.6905C56.2388 21.6905 53.2988 19.1705 53.2988 14.1905V6.48047H56.8688V14.1905C56.8688 17.0105 58.3688 18.3605 60.6188 18.3605C62.8688 18.3605 64.3688 17.0105 64.3688 14.1905Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4639 13.8898C51.4639 18.3898 48.1639 21.6898 43.4839 21.6898C38.8039 21.6898 35.5039 18.3898 35.5039 13.8898C35.5039 9.38984 38.8039 6.08984 43.4839 6.08984C48.1639 6.08984 51.4639 9.38984 51.4639 13.8898ZM43.4839 18.3598C46.0939 18.3598 47.8339 16.4998 47.8339 13.8898C47.8339 11.2798 46.0939 9.41984 43.4839 9.41984C40.8739 9.41984 39.1039 11.2798 39.1039 13.8898C39.1039 16.4998 40.8739 18.3598 43.4839 18.3598Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3516 13.77V0H21.9216V8.55H21.9816C22.9416 7.05 24.7116 6.09 26.9316 6.09C30.4716 6.09 34.2516 8.64 34.2516 13.89C34.2516 18.39 30.9516 21.69 26.2716 21.69C21.5916 21.69 18.3516 18.57 18.3516 13.77ZM26.2716 18.36C28.8816 18.36 30.6516 16.5 30.6516 13.89C30.6516 11.28 28.8816 9.42 26.2716 9.42C23.6616 9.42 21.9216 11.28 21.9216 13.89C21.9216 16.5 23.6616 18.36 26.2716 18.36Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 14.0098V21.2998H12.63V18.5398H12.57C11.76 20.4298 9.84 21.6898 7.32 21.6898C3.78 21.6898 0 19.1398 0 13.8898C0 9.38984 3.3 6.08984 7.98 6.08984C12.66 6.08984 15.9 9.23984 15.9 14.0098ZM7.98 18.3598C10.59 18.3598 12.33 16.4998 12.33 13.8898C12.33 11.2798 10.59 9.41984 7.98 9.41984C5.37 9.41984 3.6 11.2798 3.6 13.8898C3.6 16.4998 5.37 18.3598 7.98 18.3598Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3579_10533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(212.625 15.5423) rotate(93.816) scale(27.5335 45.4585)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29142,
    stopColor: "#C5D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82B5FF"
  }))))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "calendar-next",
    viewBox: "0 0 11 18",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 16L9 9L2 2",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "calendar-prev",
    viewBox: "0 0 11 18",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 16L2 9L9 2",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "notification-red",
    viewBox: "0 0 10 10",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_153_403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00011 9.16675C5.45845 9.16675 5.83345 8.79175 5.83345 8.33341H4.16678C4.16678 8.79175 4.54178 9.16675 5.00011 9.16675ZM7.50011 6.66675V4.58341C7.50011 3.30425 6.82095 2.23341 5.62511 1.95008V1.66675C5.62511 1.32091 5.34595 1.04175 5.00011 1.04175C4.65428 1.04175 4.37511 1.32091 4.37511 1.66675V1.95008C3.18345 2.23341 2.50011 3.30008 2.50011 4.58341V6.66675L1.66678 7.50008V7.91675H8.33345V7.50008L7.50011 6.66675ZM6.66678 7.08341H3.33345V4.58341C3.33345 3.55008 3.96261 2.70841 5.00011 2.70841C6.03761 2.70841 6.66678 3.55008 6.66678 4.58341V7.08341ZM3.15845 1.70008L2.56261 1.10425C1.56261 1.86675 0.904281 3.04175 0.845947 4.37508H1.67928C1.74178 3.27091 2.30845 2.30425 3.15845 1.70008ZM8.32095 4.37508H9.15428C9.09178 3.04175 8.43345 1.86675 7.43761 1.10425L6.84595 1.70008C7.68761 2.30425 8.25845 3.27091 8.32095 4.37508Z",
    fill: "#FF4B6C"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_153_403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  }))))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "refresh",
    viewBox: "0 0 30 30",
    fill: "#C5D2FF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_545_3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 11,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15 10.6V8L11.875 11.25L15 14.5V11.9C17.0687 11.9 18.75 13.6485 18.75 15.8C18.75 17.9515 17.0687 19.7 15 19.7C12.9313 19.7 11.25 17.9515 11.25 15.8H10C10 18.673 12.2375 21 15 21C17.7625 21 20 18.673 20 15.8C20 12.927 17.7625 10.6 15 10.6Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_946_7230",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.312 11.4766) rotate(93.7817) scale(23.1738 37.9186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29142,
    stopColor: "#C5D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82B5FF"
  }))))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "home",
    viewBox: "0 0 33 32",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1884 25C13.8258 25 14.3424 24.4892 14.3424 23.8592V19.2959C14.3424 18.6658 14.8591 18.1551 15.4964 18.1551H17.8044C18.4417 18.1551 18.9584 18.6658 18.9584 19.2959V23.8592C18.9584 24.4892 19.475 25 20.1124 25H23.5743C24.2117 25 24.7283 24.4892 24.7283 23.8592V16.8225C24.7283 16.2983 25.1582 15.8734 25.6884 15.8734C26.5683 15.8734 26.9847 14.8007 26.3306 14.2188L17.4224 6.29286C16.9835 5.90238 16.3173 5.90238 15.8784 6.29286L6.97014 14.2188C6.31612 14.8007 6.7325 15.8734 7.61239 15.8734C8.14262 15.8734 8.57246 16.2983 8.57246 16.8225V23.8592C8.57246 24.4892 9.08912 25 9.72645 25H13.1884Z",
    fill: "#BFD7EC"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "home-fill",
    viewBox: "0 0 33 32",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1884 25C13.8258 25 14.3424 24.4892 14.3424 23.8592V19.2959C14.3424 18.6658 14.8591 18.1551 15.4964 18.1551H17.8044C18.4417 18.1551 18.9584 18.6658 18.9584 19.2959V23.8592C18.9584 24.4892 19.475 25 20.1124 25H23.5743C24.2117 25 24.7283 24.4892 24.7283 23.8592V16.8225C24.7283 16.2983 25.1582 15.8734 25.6884 15.8734C26.5683 15.8734 26.9847 14.8007 26.3306 14.2188L17.4224 6.29286C16.9835 5.90238 16.3173 5.90238 15.8784 6.29286L6.97014 14.2188C6.31612 14.8007 6.7325 15.8734 7.61239 15.8734C8.14262 15.8734 8.57246 16.2983 8.57246 16.8225V23.8592C8.57246 24.4892 9.08912 25 9.72645 25H13.1884Z",
    fill: "#00368E"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "board",
    viewBox: "0 0 33 32",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0075 15.9125C13.0075 15.7036 13.0753 15.5033 13.1958 15.3557C13.3164 15.208 13.4799 15.125 13.6504 15.125H19.6504C19.8209 15.125 19.9844 15.208 20.105 15.3557C20.2255 15.5033 20.2932 15.7036 20.2932 15.9125C20.2932 16.1214 20.2255 16.3217 20.105 16.4693C19.9844 16.617 19.8209 16.7 19.6504 16.7H13.6504C13.4799 16.7 13.3164 16.617 13.1958 16.4693C13.0753 16.3217 13.0075 16.1214 13.0075 15.9125ZM12.1504 19.0625C12.1504 18.8536 12.2181 18.6533 12.3387 18.5057C12.4592 18.358 12.6228 18.275 12.7932 18.275H20.5075C20.678 18.275 20.8415 18.358 20.9621 18.5057C21.0827 18.6533 21.1504 18.8536 21.1504 19.0625C21.1504 19.2714 21.0827 19.4717 20.9621 19.6193C20.8415 19.767 20.678 19.85 20.5075 19.85H12.7932C12.6228 19.85 12.4592 19.767 12.3387 19.6193C12.2181 19.4717 12.1504 19.2714 12.1504 19.0625ZM13.0075 22.2125C13.0075 22.0036 13.0753 21.8033 13.1958 21.6557C13.3164 21.508 13.4799 21.425 13.6504 21.425H19.6504C19.8209 21.425 19.9844 21.508 20.105 21.6557C20.2255 21.8033 20.2932 22.0036 20.2932 22.2125C20.2932 22.4214 20.2255 22.6217 20.105 22.7693C19.9844 22.917 19.8209 23 19.6504 23H13.6504C13.4799 23 13.3164 22.917 13.1958 22.7693C13.0753 22.6217 13.0075 22.4214 13.0075 22.2125Z",
    fill: "#BFD7EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90039 27.5C9.28164 27.5 8.75214 27.2799 8.31189 26.8396C7.87164 26.3994 7.65114 25.8695 7.65039 25.25V7.25C7.65039 6.63125 7.87089 6.10175 8.31189 5.6615C8.75289 5.22125 9.28239 5.00075 9.90039 5H18.9004L25.6504 11.75V25.25C25.6504 25.8687 25.4303 26.3986 24.99 26.8396C24.5498 27.2806 24.0199 27.5007 23.4004 27.5H9.90039ZM17.7754 12.875V7.25H9.90039V25.25H23.4004V12.875H17.7754Z",
    fill: "#BFD7EC"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "board-fill",
    viewBox: "0 0 33 32",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31189 26.8396C8.75214 27.2799 9.28164 27.5 9.90039 27.5H23.4004C24.0199 27.5007 24.5498 27.2806 24.99 26.8396C25.4303 26.3986 25.6504 25.8687 25.6504 25.25V11.75L18.9004 5H9.90039C9.28239 5.00075 8.75289 5.22125 8.31189 5.6615C7.87089 6.10175 7.65039 6.63125 7.65039 7.25V25.25C7.65114 25.8695 7.87164 26.3994 8.31189 26.8396ZM23.4004 12.875H17.7754V7.25L23.4004 12.875ZM13.1958 15.3557C13.0753 15.5033 13.0075 15.7036 13.0075 15.9125C13.0075 16.1214 13.0753 16.3217 13.1958 16.4693C13.3164 16.617 13.4799 16.7 13.6504 16.7H19.6504C19.8209 16.7 19.9844 16.617 20.105 16.4693C20.2255 16.3217 20.2932 16.1214 20.2932 15.9125C20.2932 15.7036 20.2255 15.5033 20.105 15.3557C19.9844 15.208 19.8209 15.125 19.6504 15.125H13.6504C13.4799 15.125 13.3164 15.208 13.1958 15.3557ZM12.3387 18.5057C12.2181 18.6533 12.1504 18.8536 12.1504 19.0625C12.1504 19.2714 12.2181 19.4717 12.3387 19.6193C12.4592 19.767 12.6228 19.85 12.7932 19.85H20.5075C20.678 19.85 20.8415 19.767 20.9621 19.6193C21.0827 19.4717 21.1504 19.2714 21.1504 19.0625C21.1504 18.8536 21.0827 18.6533 20.9621 18.5057C20.8415 18.358 20.678 18.275 20.5075 18.275H12.7932C12.6228 18.275 12.4592 18.358 12.3387 18.5057ZM13.1958 21.6557C13.0753 21.8033 13.0075 22.0036 13.0075 22.2125C13.0075 22.4214 13.0753 22.6217 13.1958 22.7693C13.3164 22.917 13.4799 23 13.6504 23H19.6504C19.8209 23 19.9844 22.917 20.105 22.7693C20.2255 22.6217 20.2932 22.4214 20.2932 22.2125C20.2932 22.0036 20.2255 21.8033 20.105 21.6557C19.9844 21.508 19.8209 21.425 19.6504 21.425H13.6504C13.4799 21.425 13.3164 21.508 13.1958 21.6557Z",
    fill: "#00368E"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "test",
    viewBox: "0 0 33 32",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95039 9.29011V21.983C8.23305 21.4945 9.59591 21.2415 10.9754 21.2415C12.3549 21.2415 13.7177 21.4945 15.0004 21.983V9.29011C13.7489 8.66934 12.3728 8.34484 10.9754 8.34484C9.57798 8.34484 8.20188 8.66934 6.95039 9.29011ZM17.3004 9.29011V21.983C18.583 21.4945 19.9459 21.2415 21.3254 21.2415C22.7049 21.2415 24.0677 21.4945 25.3504 21.983V9.29011C24.0989 8.66934 22.7228 8.34484 21.3254 8.34484C19.928 8.34484 18.5519 8.66934 17.3004 9.29011ZM16.1504 7.25415C14.548 6.43093 12.7758 6 10.9754 6C8.95672 6 6.97361 6.54173 5.22539 7.57075C4.86958 7.78018 4.65039 8.16723 4.65039 8.58609V23.8276C4.65039 24.2464 4.86958 24.6335 5.22539 24.8429C5.5812 25.0524 6.01958 25.0524 6.37539 24.8429C7.77397 24.0197 9.36045 23.5863 10.9754 23.5863C12.5903 23.5863 14.1768 24.0197 15.5754 24.8429C15.9312 25.0524 16.3696 25.0524 16.7254 24.8429C18.124 24.0197 19.7105 23.5863 21.3254 23.5863C22.9403 23.5863 24.5268 24.0197 25.9254 24.8429C26.2812 25.0524 26.7196 25.0524 27.0754 24.8429C27.4312 24.6335 27.6504 24.2464 27.6504 23.8276V8.58609C27.6504 8.16723 27.4312 7.78018 27.0754 7.57075C25.3272 6.54173 23.3441 6 21.3254 6C19.525 6 17.7528 6.43093 16.1504 7.25415Z",
    fill: "#BFD7EC"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "test-fill",
    viewBox: "0 0 33 32",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2516 8.13941C17.9467 7.33456 19.8209 6.94535 21.7087 7.00618C23.5964 7.067 25.4396 7.57599 27.0754 8.48817C27.2303 8.57454 27.3622 8.6946 27.4606 8.83883C27.559 8.98305 27.6212 9.14746 27.6423 9.31898L27.6504 9.45005V23.8893C27.6504 24.0843 27.5972 24.2758 27.4963 24.4446C27.3954 24.6135 27.2502 24.7537 27.0754 24.8512C26.9006 24.9487 26.7022 25 26.5004 25C26.2985 25 26.1002 24.9486 25.9254 24.8512C24.5268 24.0713 22.9403 23.6607 21.3254 23.6607C19.7105 23.6607 18.124 24.0713 16.7254 24.8512C16.5506 24.9486 16.3523 25 16.1504 25C15.9485 25 15.7502 24.9486 15.5754 24.8512C14.2283 24.0999 12.7061 23.6908 11.1509 23.662C9.59563 23.6333 8.05826 23.9858 6.68244 24.6868L6.30639 24.8867L6.18794 24.9356L6.13159 24.9534L6.00509 24.9822L5.93494 24.9933L5.80039 25H5.75209L5.62559 24.9867L5.53704 24.9711L5.41284 24.9356L5.26794 24.8734L5.15869 24.8112L5.05634 24.7368L4.98734 24.6746L4.90339 24.5835L4.82979 24.4846L4.80449 24.4446L4.76769 24.378L4.71709 24.2636L4.69869 24.2092L4.66879 24.087L4.65729 24.0192L4.65269 23.9648L4.65039 23.8893V9.45005C4.6504 9.25508 4.70354 9.06355 4.80447 8.89471C4.9054 8.72586 5.05057 8.58565 5.22539 8.48817C6.86115 7.57599 8.70435 7.067 10.5921 7.00618C12.4799 6.94535 14.3541 7.33456 16.0492 8.13941L16.1504 8.18828L16.2516 8.13941Z",
    fill: "#00368E"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "bell",
    viewBox: "0 0 33 32",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1504 6.3C15.841 6.3 15.5442 6.42116 15.3254 6.63683C15.1067 6.85249 14.9837 7.145 14.9837 7.45C14.9837 7.8947 14.7236 8.29954 14.3158 8.48963C13.1674 9.0249 12.1884 9.85813 11.4838 10.9C10.784 11.9347 10.381 13.1364 10.3171 14.378V17.8C10.3171 17.8462 10.3143 17.8923 10.3087 17.9382C10.215 18.7006 9.96759 19.4355 9.58237 20.1H22.7184C22.3332 19.4355 22.0857 18.7006 21.9921 17.9382C21.9865 17.8923 21.9837 17.8462 21.9837 17.8V14.378C21.9198 13.1364 21.5168 11.9347 20.817 10.9C20.1124 9.85813 19.1334 9.0249 17.985 8.48963C17.5771 8.29954 17.317 7.8947 17.317 7.45C17.317 7.145 17.1941 6.85249 16.9753 6.63683C16.7565 6.42116 16.4598 6.3 16.1504 6.3ZM18.4837 22.4H13.8171C13.8171 23.01 14.0629 23.595 14.5005 24.0263C14.9381 24.4577 15.5316 24.7 16.1504 24.7C16.7692 24.7 17.3627 24.4577 17.8003 24.0263C18.2379 23.595 18.4837 23.01 18.4837 22.4ZM11.4838 22.4C11.4838 23.62 11.9754 24.79 12.8506 25.6527C13.7258 26.5154 14.9127 27 16.1504 27C17.3881 27 18.575 26.5154 19.4502 25.6527C20.3254 24.79 20.817 23.62 20.817 22.4H25.4836C26.0135 22.4 26.4768 22.048 26.6118 21.543C26.7468 21.038 26.5196 20.5067 26.0585 20.2493C25.5817 19.9832 25.1749 19.6104 24.871 19.1609C24.5791 18.7294 24.3899 18.2388 24.317 17.7257V14.35C24.317 14.332 24.3165 14.314 24.3157 14.2961C24.2363 12.6283 23.698 11.0134 22.7584 9.62419C21.9412 8.41589 20.8473 7.41807 19.5687 6.70908C19.4263 6.07068 19.1015 5.47991 18.6252 5.01048C17.9689 4.36348 17.0786 4 16.1504 4C15.2221 4 14.3319 4.36348 13.6755 5.01048C13.1993 5.47991 12.8745 6.07068 12.7321 6.70908C11.4535 7.41807 10.3595 8.41589 9.54234 9.62419C8.60282 11.0134 8.0645 12.6283 7.98509 14.2961C7.98424 14.314 7.98381 14.332 7.98381 14.35V17.7257C7.91092 18.2388 7.72167 18.7294 7.42981 19.1609C7.12585 19.6104 6.7191 19.9832 6.24228 20.2493C5.78122 20.5067 5.554 21.038 5.689 21.543C5.824 22.048 6.28731 22.4 6.81715 22.4H11.4838Z",
    fill: "#BFD7EC"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "bell-fill",
    viewBox: "0 0 33 32",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7574 23.55C19.7663 23.55 20.2994 24.7276 19.6263 25.4682C19.1888 25.9501 18.653 26.3356 18.0541 26.5996C17.4551 26.8635 16.8065 27 16.1504 27C15.4944 27 14.8457 26.8635 14.2468 26.5996C13.6478 26.3356 13.1121 25.9501 12.6745 25.4682C12.0306 24.7598 12.4902 23.6523 13.414 23.5581L13.5423 23.5511L18.7574 23.55ZM16.1504 4C17.7344 4 19.0735 5.03845 19.5039 6.46215L19.5575 6.6588L19.5669 6.70825C20.8529 7.42322 21.9488 8.42849 22.7646 9.64167C23.5805 10.8548 24.0932 12.2414 24.2605 13.6876L24.2932 14.0177L24.3154 14.35V17.7206L24.3399 17.8771C24.4996 18.7244 24.9752 19.4821 25.6731 20.0011L25.8679 20.1357L26.0568 20.2495C27.06 20.8095 26.71 22.2804 25.6171 22.3931L25.4818 22.4H6.81903C5.61995 22.4 5.2012 20.8314 6.24398 20.2495C6.68843 20.0015 7.07243 19.6607 7.36904 19.2508C7.66566 18.841 7.86769 18.3721 7.96096 17.8771L7.98545 17.7126L7.98662 14.2971C8.05774 12.7951 8.5012 11.3331 9.27818 10.0392C10.0552 8.74527 11.142 7.65885 12.4435 6.875L12.7328 6.7071L12.7445 6.65765C12.909 5.96975 13.2838 5.34828 13.8183 4.87727C14.3528 4.40627 15.0211 4.10847 15.7328 4.02415L15.9451 4.0046L16.1504 4Z",
    fill: "#00368E"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "mypage",
    viewBox: "0 0 33 32",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6504 7C17.8439 7 18.9885 7.47411 19.8324 8.31802C20.6763 9.16193 21.1504 10.3065 21.1504 11.5C21.1504 12.6935 20.6763 13.8381 19.8324 14.682C18.9885 15.5259 17.8439 16 16.6504 16C15.4569 16 14.3123 15.5259 13.4684 14.682C12.6245 13.8381 12.1504 12.6935 12.1504 11.5C12.1504 10.3065 12.6245 9.16193 13.4684 8.31802C14.3123 7.47411 15.4569 7 16.6504 7ZM16.6504 9.25C16.0537 9.25 15.4814 9.48705 15.0594 9.90901C14.6374 10.331 14.4004 10.9033 14.4004 11.5C14.4004 12.0967 14.6374 12.669 15.0594 13.091C15.4814 13.5129 16.0537 13.75 16.6504 13.75C17.2471 13.75 17.8194 13.5129 18.2414 13.091C18.6633 12.669 18.9004 12.0967 18.9004 11.5C18.9004 10.9033 18.6633 10.331 18.2414 9.90901C17.8194 9.48705 17.2471 9.25 16.6504 9.25ZM16.6504 17.125C19.6541 17.125 25.6504 18.6213 25.6504 21.625V25H7.65039V21.625C7.65039 18.6213 13.6466 17.125 16.6504 17.125ZM16.6504 19.2625C13.3091 19.2625 9.78789 20.905 9.78789 21.625V22.8625H23.5129V21.625C23.5129 20.905 19.9916 19.2625 16.6504 19.2625Z",
    fill: "#BFD7EC"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "mypage-fill",
    viewBox: "0 0 33 32",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6504 16C15.4129 16 14.3535 15.5594 13.4723 14.6781C12.591 13.7969 12.1504 12.7375 12.1504 11.5C12.1504 10.2625 12.591 9.20313 13.4723 8.32188C14.3535 7.44063 15.4129 7 16.6504 7C17.8879 7 18.9473 7.44063 19.8285 8.32188C20.7098 9.20313 21.1504 10.2625 21.1504 11.5C21.1504 12.7375 20.7098 13.7969 19.8285 14.6781C18.9473 15.5594 17.8879 16 16.6504 16ZM7.65039 25V21.85C7.65039 21.2125 7.81464 20.6267 8.14314 20.0927C8.47164 19.5587 8.90739 19.1508 9.45039 18.8688C10.6129 18.2875 11.7941 17.8517 12.9941 17.5615C14.1941 17.2712 15.4129 17.1257 16.6504 17.125C17.8879 17.1243 19.1066 17.2697 20.3066 17.5615C21.5066 17.8532 22.6879 18.289 23.8504 18.8688C24.3941 19.15 24.8303 19.558 25.1588 20.0927C25.4873 20.6275 25.6511 21.2133 25.6504 21.85V25H7.65039Z",
    fill: "#00368E"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "check",
    viewBox: "0 0 16 14",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 7.57666L5.76908 12.5L15 1.5",
    stroke: "#00368E",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-thick",
    viewBox: "0 0 24 25",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 14.2353L9.13167 20.949L21 5.94897",
    stroke: "#898989",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "checkbox-blue",
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10.7832L8.46842 14.3638L15.1818 6.36377",
    stroke: "#5F86BF",
    strokeWidth: 1.54545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "checkbox-grey",
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10.7832L8.46842 14.3638L15.1818 6.36377",
    stroke: "#D9D9D9",
    strokeWidth: 1.54545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-right",
    viewBox: "0 0 25 24",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8057 12C16.8057 12.2196 16.7178 12.4292 16.5635 12.5775L9.05477 19.7946C8.75103 20.0865 8.27938 20.0647 8.00132 19.7457C7.72326 19.4268 7.74408 18.9316 8.04782 18.6397L14.9558 12L8.04783 5.36033C7.74408 5.06838 7.72326 4.57317 8.00132 4.25426C8.27938 3.93534 8.75103 3.91348 9.05477 4.20543L16.5635 11.4225C16.7178 11.5708 16.8057 11.7804 16.8057 12Z",
    fill: "#898989"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "angle-up-blue",
    viewBox: "0 0 8 5",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.121048 3.8976C-0.0390477 3.75992 -0.0405293 3.53538 0.117738 3.39607L3.97606 -8.81703e-08L7.87895 3.35639C8.03905 3.49407 8.04053 3.71861 7.88226 3.85792C7.72399 3.99722 7.46591 3.99854 7.30581 3.86086L3.98268 1.00305L0.697495 3.89465C0.539228 4.03396 0.281143 4.03528 0.121048 3.8976Z",
    fill: "#00368E"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "angle-down-blue",
    viewBox: "0 0 8 5",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87895 0.602402C8.03905 0.74008 8.04053 0.96462 7.88226 1.10393L4.02394 4.5L0.121048 1.14361C-0.0390477 1.00593 -0.0405295 0.78139 0.117738 0.642084C0.276005 0.502778 0.53409 0.501458 0.694185 0.639137L4.01732 3.49695L7.30251 0.605349C7.46077 0.466043 7.71886 0.464723 7.87895 0.602402Z",
    fill: "#00368E"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "angle-down",
    viewBox: "0 0 11 7",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10937 7C4.9691 7 4.83528 6.94108 4.74057 6.83762L0.131195 1.80246C-0.055265 1.59877 -0.0413022 1.2825 0.162382 1.09604C0.366066 0.909579 0.68234 0.923542 0.868801 1.12723L5.10937 5.75951L9.34994 1.12723C9.53641 0.923543 9.85268 0.90958 10.0564 1.09604C10.26 1.2825 10.274 1.59878 10.0876 1.80246L5.47817 6.83762C5.38346 6.94108 5.24964 7 5.10937 7Z",
    fill: "#898989"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "angle-right",
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8.10938C11 8.24965 10.9412 8.38347 10.8379 8.47818L5.81049 13.0876C5.60712 13.274 5.29134 13.2601 5.10517 13.0564C4.91899 12.8527 4.93293 12.5364 5.1363 12.3499L9.76143 8.10938L5.1363 3.86881C4.93293 3.68235 4.91899 3.36607 5.10517 3.16239C5.29134 2.9587 5.60712 2.94474 5.81049 3.1312L10.8379 7.74058C10.9412 7.83529 11 7.96911 11 8.10938Z",
    fill: "currentColor"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-up-right",
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2787 7.99146C24.2766 7.30403 23.7199 6.74727 23.0325 6.74521L10.6148 6.70798C9.92444 6.70591 9.36312 7.26388 9.36105 7.95423C9.35898 8.64458 9.91695 9.2059 10.6073 9.20797L20.0205 9.23619L7.11178 22.1449C6.62363 22.6331 6.62363 23.4245 7.11178 23.9127C7.59994 24.4008 8.39139 24.4008 8.87955 23.9127L21.7877 11.0045L21.8159 20.4166C21.818 21.107 22.3793 21.6649 23.0697 21.6629C23.76 21.6608 24.318 21.0995 24.3159 20.4091L24.2787 7.99146Z",
    fill: "#00368E"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-down",
    viewBox: "0 0 11 6",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21875 6C5.08148 6 4.95053 5.94142 4.85784 5.83856L0.347142 0.832738C0.164673 0.630241 0.178338 0.315809 0.377661 0.130436C0.576984 -0.0549387 0.886488 -0.041057 1.06896 0.161441L5.21875 4.76674L9.36854 0.161441C9.55101 -0.0410562 9.86052 -0.0549379 10.0598 0.130436C10.2592 0.31581 10.2728 0.630242 10.0904 0.832739L5.57966 5.83856C5.48697 5.94142 5.35602 6 5.21875 6Z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "trash",
    viewBox: "0 0 12 16",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 12,
    height: 11,
    rx: 1,
    fill: "#FF849A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.5C8 0.223858 7.77614 0 7.5 0H5.5C5.22386 0 5 0.223858 5 0.5C5 0.776142 4.77614 1 4.5 1L1 1C0.447715 1 0 1.44772 0 2C0 2.55228 0.447715 3 1 3H11C11.5523 3 12 2.55228 12 2C12 1.44772 11.5523 1 11 1L8.5 1C8.22386 1 8 0.776142 8 0.5Z",
    fill: "#FF849A"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "instagram",
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99973 6.00268C6.89407 6.00268 6.00268 6.90264 6.00268 7.99973C6.00268 9.09683 6.90264 9.99679 7.99973 9.99679C9.09683 9.99679 9.99679 9.09683 9.99679 7.99973C9.99679 6.90264 9.09683 6.00268 7.99973 6.00268ZM13.9995 7.99973C13.9995 7.16834 13.9995 6.35409 13.9566 5.5227C13.9138 4.56274 13.6909 3.70564 12.9881 3.01138C12.2853 2.30856 11.4367 2.08571 10.4768 2.04286C9.64537 2 8.83112 2 7.99973 2C7.16834 2 6.35409 2 5.5227 2.04286C4.56274 2.08571 3.70564 2.30856 3.01138 3.01138C2.30856 3.71421 2.08571 4.56274 2.04286 5.5227C2 6.35409 2 7.16834 2 7.99973C2 8.83112 2 9.64537 2.04286 10.4768C2.08571 11.4367 2.30856 12.2938 3.01138 12.9881C3.71421 13.6909 4.56274 13.9138 5.5227 13.9566C6.35409 13.9995 7.16834 13.9995 7.99973 13.9995C8.83112 13.9995 9.64537 13.9995 10.4768 13.9566C11.4367 13.9138 12.2938 13.6909 12.9881 12.9881C13.6909 12.2853 13.9138 11.4367 13.9566 10.4768C14.008 9.65394 13.9995 8.83112 13.9995 7.99973ZM7.99973 11.0767C6.29409 11.0767 4.92273 9.70537 4.92273 7.99973C4.92273 6.29409 6.29409 4.92273 7.99973 4.92273C9.70537 4.92273 11.0767 6.29409 11.0767 7.99973C11.0767 9.70537 9.70537 11.0767 7.99973 11.0767ZM11.2053 5.51413C10.811 5.51413 10.4853 5.197 10.4853 4.79416C10.4853 4.39132 10.8025 4.07419 11.2053 4.07419C11.6081 4.07419 11.9253 4.39132 11.9253 4.79416C11.9274 4.88805 11.9103 4.98137 11.8749 5.06836C11.8395 5.15535 11.7867 5.23414 11.7196 5.29985C11.6539 5.36694 11.5751 5.41982 11.4881 5.4552C11.4011 5.49059 11.3078 5.50773 11.2139 5.50556L11.2053 5.51413Z",
    fill: "#898989"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "point",
    viewBox: "0 0 5 8",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.23816 0.765625C2.60822 0.765625 2.95402 0.802025 3.27556 0.874824C3.59709 0.941558 3.87616 1.05682 4.11276 1.22062C4.34936 1.38442 4.53439 1.60282 4.66786 1.87582C4.80739 2.14276 4.87716 2.47642 4.87716 2.87682C4.87716 3.25902 4.80739 3.59269 4.66786 3.87782C4.53439 4.15689 4.34936 4.38742 4.11276 4.56942C3.88222 4.75142 3.60922 4.88792 3.29376 4.97892C2.97829 5.06386 2.63856 5.10632 2.27456 5.10632H1.37366V7.49962H0.0268555V0.765625H2.23816ZM2.18356 4.04162C3.09962 4.04162 3.55766 3.65336 3.55766 2.87682C3.55766 2.48249 3.43632 2.20949 3.19366 2.05782C2.95706 1.90616 2.60519 1.83032 2.13806 1.83032H1.37366V4.04162H2.18356Z",
    fill: "#00368E"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "pencil",
    viewBox: "0 0 15 17",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 10,
    rx: 1,
    transform: "matrix(-0.776331 -0.630326 0.62432 -0.781169 5.88184 14.3457)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2,
    rx: 1,
    transform: "matrix(-0.776331 -0.630326 0.62432 -0.781169 12.8823 5.34375)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73799 14.7733C2.27205 14.7713 1.86917 14.4442 1.76805 13.9857L1.24882 11.6317L5.13048 14.7834L2.73799 14.7733Z"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "pencil-blue",
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.71143 18.9779C2.99913 18.9749 2.38324 18.4748 2.22865 17.7739L1.60394 14.9417L6.58998 18.99L3.71143 18.9779Z",
    fill: "#5F86BF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.70711,
    height: 2.56904,
    rx: 1.28452,
    transform: "matrix(-0.776328 -0.630329 0.624317 -0.781171 16.5469 6.86487)",
    fill: "#5F86BF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.70711,
    height: 12.8452,
    rx: 1.52874,
    transform: "matrix(-0.776328 -0.630329 0.624317 -0.781171 7.55542 18.4267)",
    fill: "#5F86BF"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "file",
    viewBox: "0 0 10 14",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 0H1.25C0.5625 0 0.00625014 0.63 0.00625014 1.4L0 12.6C0 13.37 0.55625 14 1.24375 14H8.75C9.4375 14 10 13.37 10 12.6V4.2L6.25 0ZM1.25 12.6V1.4H5.625V4.9H8.75V12.6H1.25Z",
    fill: "#00368E"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "notice-bell",
    viewBox: "0 0 11 13",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1.01514 5.56137C1.01514 3.19321 2.93491 1.27344 5.30307 1.27344C7.67123 1.27344 9.59101 3.19321 9.59101 5.56137V8.41731C9.59101 8.81185 9.27117 9.13169 8.87662 9.13169H1.72952C1.33498 9.13169 1.01514 8.81185 1.01514 8.41731V5.56137Z",
    fill: "#FF849A"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    y: 9.51953,
    width: 10.6064,
    height: 2.08275,
    rx: 1.04138,
    fill: "#FF849A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.29736,
    y: 11.1562,
    width: 2.01203,
    height: 1.84367,
    rx: 0.921834,
    fill: "#FF849A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.29736,
    y: 0.351562,
    width: 2.01203,
    height: 1.84367,
    rx: 0.921834,
    fill: "#FF849A"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "hamburger",
    viewBox: "0 0 23 15",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.107422,
    width: 22,
    height: 2.69993,
    rx: 1,
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.107422,
    y: 6.15039,
    width: 22,
    height: 2.69993,
    rx: 1,
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.107422,
    y: 12.3008,
    width: 22,
    height: 2.69993,
    rx: 1,
    fill: "#00368E"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "setting",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3076 4.38409C15.7176 4.38409 15.4216 4.38409 15.1526 4.28409L15.0416 4.23809C14.7806 4.11809 14.5716 3.91009 14.1536 3.49209C13.1916 2.53009 12.7106 2.04909 12.1196 2.00409C12.0397 1.99929 11.9595 1.99929 11.8796 2.00409C11.2886 2.04909 10.8076 2.53009 9.8456 3.49209C9.4276 3.91009 9.2186 4.11909 8.9576 4.23809L8.8476 4.28409C8.5776 4.38409 8.2826 4.38409 7.6916 4.38409H7.5816C6.0746 4.38409 5.3206 4.38409 4.8516 4.85209C4.3826 5.32009 4.3836 6.07509 4.3836 7.58209V7.69209C4.3836 8.28209 4.3836 8.57809 4.2836 8.84709C4.26894 8.88509 4.2536 8.92209 4.2376 8.95809C4.1176 9.21909 3.9096 9.42809 3.4916 9.84609C2.5296 10.8081 2.0486 11.2891 2.0036 11.8801C1.9988 11.96 1.9988 12.0402 2.0036 12.1201C2.0486 12.7111 2.5296 13.1921 3.4916 14.1541C3.9096 14.5721 4.1186 14.7811 4.2376 15.0421C4.25427 15.0781 4.2696 15.1148 4.2836 15.1521C4.3836 15.4221 4.3836 15.7171 4.3836 16.3081V16.4181C4.3836 17.9251 4.3836 18.6791 4.8516 19.1481C5.3196 19.6171 6.0746 19.6161 7.5816 19.6161H7.6916C8.2816 19.6161 8.5776 19.6161 8.8466 19.7161C8.8846 19.7301 8.9216 19.7454 8.9576 19.7621C9.2186 19.8821 9.4276 20.0901 9.8456 20.5081C10.8076 21.4701 11.2886 21.9511 11.8796 21.9961C11.9596 22.0021 12.0396 22.0021 12.1196 21.9961C12.7106 21.9511 13.1916 21.4701 14.1536 20.5081C14.5716 20.0901 14.7806 19.8821 15.0416 19.7621C15.0776 19.7454 15.1143 19.7301 15.1516 19.7161C15.4216 19.6161 15.7166 19.6161 16.3076 19.6161H16.4176C17.9246 19.6161 18.6786 19.6161 19.1476 19.1481C19.6166 18.6801 19.6156 17.9251 19.6156 16.4181V16.3081C19.6156 15.7181 19.6156 15.4221 19.7156 15.1531C19.7296 15.1151 19.7449 15.0781 19.7616 15.0421C19.8816 14.7811 20.0896 14.5721 20.5076 14.1541C21.4696 13.1921 21.9506 12.7111 21.9956 12.1201C22.0016 12.0401 22.0016 11.9601 21.9956 11.8801C21.9506 11.2891 21.4696 10.8081 20.5076 9.84609C20.0896 9.42809 19.8816 9.21909 19.7616 8.95809L19.7156 8.84809C19.6156 8.57809 19.6156 8.28309 19.6156 7.69209V7.58209C19.6156 6.07509 19.6156 5.32109 19.1476 4.85209C18.6796 4.38309 17.9246 4.38409 16.4176 4.38409H16.3076Z",
    stroke: "#00368E",
    strokeWidth: 1.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12C15.5 12.4596 15.4095 12.9148 15.2336 13.3394C15.0577 13.764 14.7999 14.1499 14.4749 14.4749C14.1499 14.7999 13.764 15.0577 13.3394 15.2336C12.9148 15.4095 12.4596 15.5 12 15.5C11.5404 15.5 11.0852 15.4095 10.6606 15.2336C10.236 15.0577 9.85013 14.7999 9.52513 14.4749C9.20012 14.1499 8.94231 13.764 8.76642 13.3394C8.59053 12.9148 8.5 12.4596 8.5 12C8.5 11.0717 8.86875 10.1815 9.52513 9.52513C10.1815 8.86875 11.0717 8.5 12 8.5C12.9283 8.5 13.8185 8.86875 14.4749 9.52513C15.1313 10.1815 15.5 11.0717 15.5 12Z",
    stroke: "#00368E",
    strokeWidth: 1.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-circle",
    viewBox: "0 0 15 15",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1440_9507)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 13.6364C10.889 13.6364 13.6364 10.889 13.6364 7.5C13.6364 4.11098 10.889 1.36364 7.5 1.36364C4.11098 1.36364 1.36364 4.11098 1.36364 7.5C1.36364 10.889 4.11098 13.6364 7.5 13.6364ZM7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8078 5.20886C11.0641 5.48733 11.0641 5.93883 10.8078 6.2173L6.40625 11L4.19221 8.59423C3.93593 8.31576 3.93593 7.86426 4.19221 7.58579C4.44849 7.30731 4.86401 7.30731 5.12029 7.58579L6.40625 8.98311L9.87971 5.20886C10.136 4.93038 10.5515 4.93038 10.8078 5.20886Z",
    fill: "#484848"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1440_9507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  }))))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-circle-fill",
    viewBox: "0 0 33 33",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.6104,
    cy: 16.5,
    r: 16.5,
    fill: "#FEE9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1104 17L14.1104 21L23.1104 12",
    stroke: "#FF4B6C",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "abuse-comment",
    viewBox: "0 0 25 20",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 3.12061C25 2.6797 24.6426 2.32227 24.2017 2.32227H0.798344C0.357431 2.32227 0 2.6797 0 3.12061V16.2911C0 16.7321 0.357431 17.0895 0.798344 17.0895H19.0771C19.3821 17.0895 19.6604 17.2633 19.7943 17.5373L20.7827 19.5597C21.0745 20.1568 21.9255 20.1568 22.2173 19.5597L23.2057 17.5373C23.3396 17.2633 23.6179 17.0895 23.9229 17.0895H24.2017C24.6426 17.0895 25 16.7321 25 16.2911V3.12061Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11.1839L11 8.23047",
    stroke: "#898989",
    strokeWidth: 0.830319
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90645 7.63533L6.325 13.9915",
    stroke: "#898989",
    strokeWidth: 0.830319
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12.1683L11 9.21484",
    stroke: "#898989",
    strokeWidth: 0.830319
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90651 6.64919L9.32544 13.0051",
    stroke: "#898989",
    strokeWidth: 0.830319
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1286 14.183H13.1622V12.529C13.9493 12.26 14.7564 11.9312 14.7564 11.0145C14.7564 10.4665 14.318 9.99818 13.7102 9.99818C13.0625 9.99818 12.644 10.4266 12.644 11.1141V11.1938H11.7373V11.154C11.7373 9.98822 12.654 9.18115 13.7102 9.18115C14.856 9.18115 15.6631 10.1177 15.6631 10.9846C15.6631 12.2301 14.8859 12.6984 14.1286 13.0471V14.183ZM14.1685 16.2754H13.1223V15.1196H14.1685V16.2754Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5935 4.1818L18.2734 5.38557L20.4891 9.53325L19.4446 9.90447L17.0177 5.83186L16.3378 4.62809L17.5935 4.1818ZM21.8692 11.7773L20.6369 12.2152L19.9265 10.9572L21.1587 10.5193L21.8692 11.7773Z",
    fill: "#898989"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "dollar",
    viewBox: "0 0 25 14",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 14,
    rx: 1,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 7.5,
    r: 5.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.27 9.208L10.855 8.659C11.269 9.082 11.764 9.379 12.394 9.379C13.015 9.379 13.681 9.082 13.681 8.335C13.681 7.651 13.015 7.426 12.313 7.174C11.512 6.886 10.648 6.562 10.648 5.482C10.648 4.6 11.332 3.997 12.259 3.925V3.07H12.835V3.943C13.357 3.997 13.843 4.195 14.311 4.528L13.798 5.131C13.456 4.825 13.006 4.654 12.502 4.654C12.016 4.654 11.458 4.897 11.458 5.482C11.458 6.022 12.052 6.229 12.718 6.463C13.564 6.76 14.527 7.102 14.527 8.245C14.527 9.316 13.753 9.946 12.79 10.081V10.954H12.214V10.108C11.476 10.081 10.855 9.766 10.27 9.208Z",
    fill: "#898989"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "camera",
    viewBox: "0 0 25 18",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1C16 0.447715 15.5523 0 15 0H10C9.44772 0 9 0.447715 9 1C9 1.55228 8.55229 2 8 2H1C0.447715 2 0 2.44772 0 3V17C0 17.5523 0.447716 18 1 18H24C24.5523 18 25 17.5523 25 17V3C25 2.44772 24.5523 2 24 2H17C16.4477 2 16 1.55228 16 1Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 10.5,
    r: 5.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 10.5,
    r: 3.5,
    fill: "#898989"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "user-disgust",
    viewBox: "0 0 20 22",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.25,
    cy: 5.25,
    r: 5.25,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 12,
    width: 18,
    height: 9,
    rx: 2,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.6779,
    y: 2,
    width: 2,
    height: 25,
    transform: "rotate(45 17.6779 2)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 25,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 1.41418 2)",
    fill: "#898989"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "user-sunglasses",
    viewBox: "0 0 18 21",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.25,
    cy: 5.25,
    r: 5.25,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 18,
    height: 9,
    rx: 2,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 4C4.58819 6.66667 7.41181 6.66667 9 4L3 4Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4C10.5882 6.66667 13.4118 6.66667 15 4L9 4Z",
    fill: "#898989"
  }))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "user-stranger",
    viewBox: "0 0 18 21",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.25,
    cy: 5.25,
    r: 5.25,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 18,
    height: 9,
    rx: 2,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5685 12.5183H11.7221V9.37079C13.2259 8.85885 14.7678 8.23315 14.7678 6.48876C14.7678 5.44593 13.9302 4.55477 12.769 4.55477C11.5317 4.55477 10.7322 5.37008 10.7322 6.67837V6.83006H9V6.75421C9 4.53581 10.7513 3 12.769 3C14.9581 3 16.5 4.7823 16.5 6.43188C16.5 8.80197 15.0152 9.69312 13.5685 10.3567V12.5183ZM13.6447 16.5H11.6459V14.3006H13.6447V16.5Z",
    fill: "#898989"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    id: "user",
    viewBox: "0 0 18 21",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.25,
    cy: 5.25,
    r: 5.25,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 18,
    height: 9,
    rx: 2,
    fill: "#F0F0F0"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    id: "search",
    viewBox: "0 0 14 15",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.93724 10.5109L13 13.6055M9.85198 3.12036C11.8954 5.15868 11.9165 8.48477 9.89912 10.5494C7.88176 12.614 4.58986 12.6353 2.54646 10.597C0.503064 8.5587 0.48196 5.23261 2.49932 3.16799C4.51669 1.10337 7.80859 1.08205 9.85198 3.12036Z",
    stroke: "#898989",
    strokeWidth: 1,
    strokeLinecap: "round"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "search-thick",
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9163 13.8739L18 18M13.8026 4.01986C16.5272 6.73762 16.5553 11.1724 13.8655 13.9252C11.1757 16.678 6.78648 16.7065 4.06195 13.9887C1.33742 11.271 1.30928 6.83619 3.9991 4.08336C6.68892 1.33054 11.0781 1.30211 13.8026 4.01986Z",
    stroke: "#00368E",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    id: "snow-circle-pink",
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#FF4B6C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4237 20.65L24.7753 19.668C25.0736 19.3511 25.4157 19.0815 25.7905 18.868C26.0356 18.7255 26.2161 18.489 26.2929 18.2099C26.3696 17.9308 26.3363 17.6317 26.2003 17.3778C26.0642 17.1239 25.8364 16.9356 25.5664 16.8541C25.2965 16.7726 25.0062 16.8044 24.7589 16.9425C24.0432 17.351 23.409 17.8956 22.8899 18.5475L18.6182 16L22.8889 13.457C23.408 14.109 24.0422 14.6536 24.7579 15.062C24.8806 15.1333 25.0157 15.1789 25.1556 15.1961C25.2954 15.2133 25.4372 15.2017 25.5727 15.1621C25.7082 15.1225 25.8347 15.0556 25.945 14.9652C26.0553 14.8749 26.1471 14.7629 26.2153 14.6358C26.2834 14.5087 26.3264 14.3689 26.3419 14.2245C26.3573 14.0802 26.3449 13.9341 26.3053 13.7947C26.2657 13.6553 26.1998 13.5254 26.1113 13.4124C26.0228 13.2994 25.9134 13.2057 25.7896 13.1365C25.4148 12.9228 25.0727 12.6533 24.7744 12.3365L26.4227 11.3545C26.5488 11.285 26.6601 11.19 26.7499 11.0753C26.8397 10.9605 26.9062 10.8283 26.9454 10.6866C26.9847 10.5448 26.9959 10.3963 26.9784 10.2499C26.961 10.1036 26.9151 9.96237 26.8437 9.83465C26.7722 9.70694 26.6766 9.59534 26.5625 9.5065C26.4484 9.41766 26.3181 9.35339 26.1794 9.31751C26.0407 9.28163 25.8965 9.27486 25.7552 9.29762C25.614 9.32038 25.4786 9.3722 25.3571 9.45L23.7088 10.4315C23.5913 10.0065 23.5355 9.56588 23.543 9.124C23.546 8.97929 23.5214 8.83537 23.4705 8.7005C23.4195 8.56563 23.3433 8.44245 23.2461 8.33803C23.1489 8.23362 23.0326 8.15001 22.9041 8.092C22.7755 8.03399 22.6371 8.00273 22.4967 8H22.4769C22.1974 7.99995 21.9291 8.11302 21.7296 8.3149C21.5301 8.51678 21.4155 8.79133 21.4103 9.0795C21.3952 9.92244 21.5351 10.7607 21.8224 11.55L17.5516 14.0945V9.009C18.3586 8.87146 19.1329 8.57744 19.8337 8.1425C20.076 7.99192 20.2504 7.74824 20.3184 7.46506C20.3865 7.18188 20.3428 6.8824 20.1968 6.6325C20.0508 6.3826 19.8145 6.20275 19.5399 6.13252C19.2653 6.06229 18.975 6.10742 18.7326 6.258C18.3653 6.48566 17.9673 6.656 17.5516 6.7635V5.1C17.5516 4.80826 17.4393 4.52847 17.2392 4.32218C17.0392 4.11589 16.7679 4 16.4851 4C16.2022 4 15.9309 4.11589 15.7309 4.32218C15.5308 4.52847 15.4185 4.80826 15.4185 5.1V6.7635C15.0028 6.656 14.6048 6.48566 14.2375 6.258C13.9952 6.10742 13.7048 6.06229 13.4302 6.13252C13.1556 6.20275 12.9193 6.3826 12.7733 6.6325C12.6273 6.8824 12.5836 7.18188 12.6517 7.46506C12.7198 7.74824 12.8941 7.99192 13.1365 8.1425C13.8372 8.57744 14.6115 8.87146 15.4185 9.009V14.0945L11.1478 11.55C11.4355 10.7605 11.5757 9.92184 11.5608 9.0785C11.5556 8.79033 11.4409 8.51578 11.2415 8.3139C11.042 8.11202 10.7737 7.99895 10.4942 7.999H10.4734C10.3333 8.00167 10.1951 8.03277 10.0667 8.09053C9.93829 8.14829 9.82216 8.23157 9.72496 8.33562C9.62776 8.43968 9.55139 8.56246 9.50021 8.69696C9.44903 8.83146 9.42404 8.97504 9.42667 9.1195C9.43452 9.56202 9.37881 10.0033 9.26135 10.429L7.61299 9.45C7.49161 9.37532 7.35704 9.32628 7.21711 9.3057C7.07719 9.28513 6.93469 9.29345 6.79791 9.33016C6.66113 9.36688 6.53279 9.43127 6.42035 9.5196C6.3079 9.60792 6.2136 9.7184 6.14293 9.84464C6.07225 9.97087 6.0266 10.1103 6.00865 10.2549C5.99069 10.3995 6.00077 10.5463 6.03831 10.6869C6.07585 10.8274 6.1401 10.9588 6.22733 11.0735C6.31455 11.1882 6.42301 11.2839 6.5464 11.355L8.19477 12.337C7.8964 12.6538 7.55431 12.9233 7.17957 13.137C7.05572 13.2062 6.94639 13.2999 6.85787 13.4129C6.76935 13.5259 6.7034 13.6558 6.66382 13.7952C6.62424 13.9346 6.61183 14.0807 6.62729 14.225C6.64274 14.3694 6.68577 14.5092 6.75389 14.6363C6.822 14.7634 6.91385 14.8754 7.02414 14.9657C7.13443 15.0561 7.26097 15.123 7.39647 15.1626C7.53196 15.2022 7.67372 15.2138 7.81356 15.1966C7.95341 15.1794 8.08857 15.1338 8.21125 15.0625C8.92691 14.654 9.56107 14.1094 10.0802 13.4575L14.3519 16L10.0812 18.543C9.56204 17.8911 8.92788 17.3465 8.21222 16.938C8.08954 16.8667 7.95438 16.8211 7.81453 16.8039C7.67469 16.7867 7.53293 16.7983 7.39744 16.8379C7.26194 16.8775 7.1354 16.9444 7.02511 17.0348C6.91482 17.1251 6.82297 17.2371 6.75486 17.3642C6.68674 17.4913 6.64371 17.6311 6.62825 17.7755C6.6128 17.9198 6.62521 18.0659 6.66479 18.2053C6.70436 18.3447 6.77032 18.4746 6.85884 18.5876C6.94736 18.7006 7.05669 18.7943 7.18054 18.8635C7.55528 19.0772 7.89737 19.3467 8.19573 19.6635L6.5464 20.65C6.42301 20.7211 6.31455 20.8168 6.22733 20.9315C6.1401 21.0462 6.07585 21.1776 6.03831 21.3181C6.00077 21.4587 5.99069 21.6055 6.00865 21.7501C6.0266 21.8947 6.07225 22.0341 6.14293 22.1604C6.2136 22.2866 6.3079 22.3971 6.42035 22.4854C6.53279 22.5737 6.66113 22.6381 6.79791 22.6748C6.93469 22.7116 7.07719 22.7199 7.21711 22.6993C7.35704 22.6787 7.49161 22.6297 7.61299 22.555L9.26135 21.5735C9.37878 21.9985 9.43465 22.4391 9.42716 22.881C9.42223 23.1724 9.52963 23.4539 9.72579 23.6637C9.92195 23.8735 10.1908 23.9945 10.4734 24H10.4933C10.7727 24 11.041 23.887 11.2405 23.6851C11.44 23.4832 11.5546 23.2087 11.5598 22.9205C11.5749 22.0776 11.4351 21.2393 11.1478 20.45L15.4185 17.9055V22.991C14.6115 23.1285 13.8372 23.4226 13.1365 23.8575C12.8941 24.0081 12.7198 24.2518 12.6517 24.5349C12.5836 24.8181 12.6273 25.1176 12.7733 25.3675C12.9193 25.6174 13.1556 25.7973 13.4302 25.8675C13.7048 25.9377 13.9952 25.8926 14.2375 25.742C14.6048 25.5143 15.0028 25.344 15.4185 25.2365V26.9C15.4185 27.1917 15.5308 27.4715 15.7309 27.6778C15.9309 27.8841 16.2022 28 16.4851 28C16.7679 28 17.0392 27.8841 17.2392 27.6778C17.4393 27.4715 17.5516 27.1917 17.5516 26.9V25.2365C17.9673 25.344 18.3653 25.5143 18.7326 25.742C18.975 25.8926 19.2653 25.9377 19.5399 25.8675C19.8145 25.7972 20.0508 25.6174 20.1968 25.3675C20.3428 25.1176 20.3865 24.8181 20.3184 24.5349C20.2504 24.2518 20.076 24.0081 19.8337 23.8575C19.1329 23.4226 18.3586 23.1285 17.5516 22.991V17.9055L21.8224 20.45C21.5346 21.2395 21.3945 22.0782 21.4093 22.9215C21.4145 23.2097 21.5292 23.4842 21.7286 23.6861C21.9281 23.888 22.1964 24.001 22.4759 24.001H22.4967C22.6368 23.9983 22.775 23.9672 22.9034 23.9095C23.0318 23.8517 23.148 23.7684 23.2452 23.6644C23.3424 23.5603 23.4187 23.4375 23.4699 23.303C23.5211 23.1685 23.5461 23.025 23.5434 22.8805C23.5356 22.438 23.5913 21.9967 23.7088 21.571L25.3571 22.5525C25.4785 22.6329 25.6144 22.687 25.7567 22.7117C25.8989 22.7363 26.0446 22.731 26.1847 22.6959C26.3249 22.6609 26.4568 22.5968 26.5723 22.5077C26.6878 22.4186 26.7846 22.3063 26.8568 22.1775C26.929 22.0487 26.9751 21.9061 26.9923 21.7584C27.0096 21.6107 26.9976 21.461 26.9571 21.3182C26.9167 21.1754 26.8485 21.0426 26.7568 20.9277C26.6651 20.8129 26.5518 20.7184 26.4237 20.65Z",
    fill: "#FF4B6C"
  }))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    id: "snow-circle-blue",
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#00368E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4237 20.65L24.7753 19.668C25.0736 19.3511 25.4157 19.0815 25.7905 18.868C26.0356 18.7255 26.2161 18.489 26.2929 18.2099C26.3696 17.9308 26.3363 17.6317 26.2003 17.3778C26.0642 17.1239 25.8364 16.9356 25.5664 16.8541C25.2965 16.7726 25.0062 16.8044 24.7589 16.9425C24.0432 17.351 23.409 17.8956 22.8899 18.5475L18.6182 16L22.8889 13.457C23.408 14.109 24.0422 14.6536 24.7579 15.062C24.8806 15.1333 25.0157 15.1789 25.1556 15.1961C25.2954 15.2133 25.4372 15.2017 25.5727 15.1621C25.7082 15.1225 25.8347 15.0556 25.945 14.9652C26.0553 14.8749 26.1471 14.7629 26.2153 14.6358C26.2834 14.5087 26.3264 14.3689 26.3419 14.2245C26.3573 14.0802 26.3449 13.9341 26.3053 13.7947C26.2657 13.6553 26.1998 13.5254 26.1113 13.4124C26.0228 13.2994 25.9134 13.2057 25.7896 13.1365C25.4148 12.9228 25.0727 12.6533 24.7744 12.3365L26.4227 11.3545C26.5488 11.285 26.6601 11.19 26.7499 11.0753C26.8397 10.9605 26.9062 10.8283 26.9454 10.6866C26.9847 10.5448 26.9959 10.3963 26.9784 10.2499C26.961 10.1036 26.9151 9.96237 26.8437 9.83465C26.7722 9.70694 26.6766 9.59534 26.5625 9.5065C26.4484 9.41766 26.3181 9.35339 26.1794 9.31751C26.0407 9.28163 25.8965 9.27486 25.7552 9.29762C25.614 9.32038 25.4786 9.3722 25.3571 9.45L23.7088 10.4315C23.5913 10.0065 23.5355 9.56588 23.543 9.124C23.546 8.97929 23.5214 8.83537 23.4705 8.7005C23.4195 8.56563 23.3433 8.44245 23.2461 8.33803C23.1489 8.23362 23.0326 8.15001 22.9041 8.092C22.7755 8.03399 22.6371 8.00273 22.4967 8H22.4769C22.1974 7.99995 21.9291 8.11302 21.7296 8.3149C21.5301 8.51678 21.4155 8.79133 21.4103 9.0795C21.3952 9.92244 21.5351 10.7607 21.8224 11.55L17.5516 14.0945V9.009C18.3586 8.87146 19.1329 8.57744 19.8337 8.1425C20.076 7.99192 20.2504 7.74824 20.3184 7.46506C20.3865 7.18188 20.3428 6.8824 20.1968 6.6325C20.0508 6.3826 19.8145 6.20275 19.5399 6.13252C19.2653 6.06229 18.975 6.10742 18.7326 6.258C18.3653 6.48566 17.9673 6.656 17.5516 6.7635V5.1C17.5516 4.80826 17.4393 4.52847 17.2392 4.32218C17.0392 4.11589 16.7679 4 16.4851 4C16.2022 4 15.9309 4.11589 15.7309 4.32218C15.5308 4.52847 15.4185 4.80826 15.4185 5.1V6.7635C15.0028 6.656 14.6048 6.48566 14.2375 6.258C13.9952 6.10742 13.7048 6.06229 13.4302 6.13252C13.1556 6.20275 12.9193 6.3826 12.7733 6.6325C12.6273 6.8824 12.5836 7.18188 12.6517 7.46506C12.7198 7.74824 12.8941 7.99192 13.1365 8.1425C13.8372 8.57744 14.6115 8.87146 15.4185 9.009V14.0945L11.1478 11.55C11.4355 10.7605 11.5757 9.92184 11.5608 9.0785C11.5556 8.79033 11.4409 8.51578 11.2415 8.3139C11.042 8.11202 10.7737 7.99895 10.4942 7.999H10.4734C10.3333 8.00167 10.1951 8.03277 10.0667 8.09053C9.93829 8.14829 9.82216 8.23157 9.72496 8.33562C9.62776 8.43968 9.55139 8.56246 9.50021 8.69696C9.44903 8.83146 9.42404 8.97504 9.42667 9.1195C9.43452 9.56202 9.37881 10.0033 9.26135 10.429L7.61299 9.45C7.49161 9.37532 7.35704 9.32628 7.21711 9.3057C7.07719 9.28513 6.93469 9.29345 6.79791 9.33016C6.66113 9.36688 6.53279 9.43127 6.42035 9.5196C6.3079 9.60792 6.2136 9.7184 6.14293 9.84464C6.07225 9.97087 6.0266 10.1103 6.00865 10.2549C5.99069 10.3995 6.00077 10.5463 6.03831 10.6869C6.07585 10.8274 6.1401 10.9588 6.22733 11.0735C6.31455 11.1882 6.42301 11.2839 6.5464 11.355L8.19477 12.337C7.8964 12.6538 7.55431 12.9233 7.17957 13.137C7.05572 13.2062 6.94639 13.2999 6.85787 13.4129C6.76935 13.5259 6.7034 13.6558 6.66382 13.7952C6.62424 13.9346 6.61183 14.0807 6.62729 14.225C6.64274 14.3694 6.68577 14.5092 6.75389 14.6363C6.822 14.7634 6.91385 14.8754 7.02414 14.9657C7.13443 15.0561 7.26097 15.123 7.39647 15.1626C7.53196 15.2022 7.67372 15.2138 7.81356 15.1966C7.95341 15.1794 8.08857 15.1338 8.21125 15.0625C8.92691 14.654 9.56107 14.1094 10.0802 13.4575L14.3519 16L10.0812 18.543C9.56204 17.8911 8.92788 17.3465 8.21222 16.938C8.08954 16.8667 7.95438 16.8211 7.81453 16.8039C7.67469 16.7867 7.53293 16.7983 7.39744 16.8379C7.26194 16.8775 7.1354 16.9444 7.02511 17.0348C6.91482 17.1251 6.82297 17.2371 6.75486 17.3642C6.68674 17.4913 6.64371 17.6311 6.62825 17.7755C6.6128 17.9198 6.62521 18.0659 6.66479 18.2053C6.70436 18.3447 6.77032 18.4746 6.85884 18.5876C6.94736 18.7006 7.05669 18.7943 7.18054 18.8635C7.55528 19.0772 7.89737 19.3467 8.19573 19.6635L6.5464 20.65C6.42301 20.7211 6.31455 20.8168 6.22733 20.9315C6.1401 21.0462 6.07585 21.1776 6.03831 21.3181C6.00077 21.4587 5.99069 21.6055 6.00865 21.7501C6.0266 21.8947 6.07225 22.0341 6.14293 22.1604C6.2136 22.2866 6.3079 22.3971 6.42035 22.4854C6.53279 22.5737 6.66113 22.6381 6.79791 22.6748C6.93469 22.7116 7.07719 22.7199 7.21711 22.6993C7.35704 22.6787 7.49161 22.6297 7.61299 22.555L9.26135 21.5735C9.37878 21.9985 9.43465 22.4391 9.42716 22.881C9.42223 23.1724 9.52963 23.4539 9.72579 23.6637C9.92195 23.8735 10.1908 23.9945 10.4734 24H10.4933C10.7727 24 11.041 23.887 11.2405 23.6851C11.44 23.4832 11.5546 23.2087 11.5598 22.9205C11.5749 22.0776 11.4351 21.2393 11.1478 20.45L15.4185 17.9055V22.991C14.6115 23.1285 13.8372 23.4226 13.1365 23.8575C12.8941 24.0081 12.7198 24.2518 12.6517 24.5349C12.5836 24.8181 12.6273 25.1176 12.7733 25.3675C12.9193 25.6174 13.1556 25.7973 13.4302 25.8675C13.7048 25.9377 13.9952 25.8926 14.2375 25.742C14.6048 25.5143 15.0028 25.344 15.4185 25.2365V26.9C15.4185 27.1917 15.5308 27.4715 15.7309 27.6778C15.9309 27.8841 16.2022 28 16.4851 28C16.7679 28 17.0392 27.8841 17.2392 27.6778C17.4393 27.4715 17.5516 27.1917 17.5516 26.9V25.2365C17.9673 25.344 18.3653 25.5143 18.7326 25.742C18.975 25.8926 19.2653 25.9377 19.5399 25.8675C19.8145 25.7972 20.0508 25.6174 20.1968 25.3675C20.3428 25.1176 20.3865 24.8181 20.3184 24.5349C20.2504 24.2518 20.076 24.0081 19.8337 23.8575C19.1329 23.4226 18.3586 23.1285 17.5516 22.991V17.9055L21.8224 20.45C21.5346 21.2395 21.3945 22.0782 21.4093 22.9215C21.4145 23.2097 21.5292 23.4842 21.7286 23.6861C21.9281 23.888 22.1964 24.001 22.4759 24.001H22.4967C22.6368 23.9983 22.775 23.9672 22.9034 23.9095C23.0318 23.8517 23.148 23.7684 23.2452 23.6644C23.3424 23.5603 23.4187 23.4375 23.4699 23.303C23.5211 23.1685 23.5461 23.025 23.5434 22.8805C23.5356 22.438 23.5913 21.9967 23.7088 21.571L25.3571 22.5525C25.4785 22.6329 25.6144 22.687 25.7567 22.7117C25.8989 22.7363 26.0446 22.731 26.1847 22.6959C26.3249 22.6609 26.4568 22.5968 26.5723 22.5077C26.6878 22.4186 26.7846 22.3063 26.8568 22.1775C26.929 22.0487 26.9751 21.9061 26.9923 21.7584C27.0096 21.6107 26.9976 21.461 26.9571 21.3182C26.9167 21.1754 26.8485 21.0426 26.7568 20.9277C26.6651 20.8129 26.5518 20.7184 26.4237 20.65Z",
    fill: "#00368E"
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    id: "heart-plus",
    viewBox: "0 0 40 40",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6472_15067)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_radial_6472_15067)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6472_15067)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.999,
    cy: 19.6162,
    r: 16.5889,
    fill: "url(#paint1_radial_6472_15067)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_6472_15067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1027 13.753C32.6411 16.2915 32.6411 20.407 30.1027 22.9454L20.5567 32.4914C20.1662 32.8819 19.533 32.8819 19.1425 32.4914L9.59656 22.9454C7.05815 20.407 7.05815 16.2915 9.59656 13.753C12.135 11.2146 16.2505 11.2146 18.7889 13.753L19.8496 14.8137L20.9103 13.753C23.4487 11.2146 27.5643 11.2146 30.1027 13.753Z",
    fill: "url(#paint2_radial_6472_15067)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_6472_15067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3955 21.1387C27.8924 21.1388 28.2958 21.5422 28.2959 22.0391V25.9941H32.2646C32.7616 25.9942 33.165 26.3975 33.165 26.8945C33.1649 27.3914 32.7615 27.7948 32.2646 27.7949H28.2959V31.7627C28.2959 32.2597 27.8925 32.663 27.3955 32.6631C26.8985 32.6631 26.4951 32.2598 26.4951 31.7627V27.7949H22.541C22.044 27.7949 21.6407 27.3915 21.6406 26.8945C21.6406 26.3975 22.044 25.9941 22.541 25.9941H26.4951V22.0391C26.4952 21.5421 26.8985 21.1387 27.3955 21.1387Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6472_15067",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.508334
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620678 0 0 0 0 0.749007 0 0 0 0 0.991406 0 0 0 0.91 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6472_15067"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6472_15067",
    x: 2.39349,
    y: 2.89349,
    width: 35.2111,
    height: 35.2111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.508334
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620678 0 0 0 0 0.749007 0 0 0 0 0.991406 0 0 0 0.82 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6472_15067"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6472_15067",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_6472_15067",
    x: 7.69287,
    y: 11.8491,
    width: 24.3135,
    height: 20.9351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.32651
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620678 0 0 0 0 0.749007 0 0 0 0 0.991406 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6472_15067"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_6472_15067",
    x: 19.0422,
    y: 18.5403,
    width: 16.7212,
    height: 16.7212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2992
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.510286 0 0 0 0 0.709233 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6472_15067"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6472_15067",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6472_15067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.2247 20.7247) rotate(77.364) scale(65.5043)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79AFFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6472_15067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.1854 20.6854) rotate(85.369) scale(15.31)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_6472_15067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13 25.5) rotate(-40.3999) scale(30.8585)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2EDFF"
  }))))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    id: "heart-minus",
    viewBox: "0 0 40 40",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6472_15122)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_radial_6472_15122)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6472_15122)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.999,
    cy: 19.6162,
    r: 16.5889,
    fill: "url(#paint1_radial_6472_15122)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_6472_15122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1027 12.8702C32.6411 15.4086 32.6411 19.5242 30.1027 22.0626L20.5567 31.6086C20.1662 31.9991 19.533 31.9991 19.1425 31.6086L9.59656 22.0626C7.05815 19.5242 7.05815 15.4086 9.59656 12.8702C12.135 10.3318 16.2505 10.3318 18.7889 12.8702L19.8496 13.9309L20.9103 12.8702C23.4487 10.3318 27.5643 10.3318 30.1027 12.8702Z",
    fill: "url(#paint2_radial_6472_15122)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_6472_15122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2646 25.1113C32.7616 25.1114 33.165 25.5147 33.165 26.0117C33.1649 26.5086 32.7615 26.912 32.2646 26.9121H22.541C22.044 26.9121 21.6407 26.5087 21.6406 26.0117C21.6406 25.5147 22.044 25.1113 22.541 25.1113H32.2646Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6472_15122",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.508334
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.517647 0 0 0 0 0.603922 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6472_15122"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6472_15122",
    x: 2.39349,
    y: 2.01068,
    width: 35.2111,
    height: 35.2111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.508334
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.517647 0 0 0 0 0.603922 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6472_15122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6472_15122",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_6472_15122",
    x: 7.69287,
    y: 10.9663,
    width: 24.3135,
    height: 20.9351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.32651
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.517647 0 0 0 0 0.603922 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6472_15122"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_6472_15122",
    x: 19.0422,
    y: 22.5129,
    width: 16.7212,
    height: 6.9976,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2992
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.541176 0 0 0 0 0.623529 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6472_15122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6472_15122",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6472_15122",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 20) rotate(90) scale(27.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE9EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6472_15122",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.1854 19.8026) rotate(90.6511) scale(16.4035)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE9EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_6472_15122",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13 24.6172) rotate(-40.3999) scale(30.8585)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE9EB"
  }))))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    id: "triangle-exclamation-circle",
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#00368E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25167 23H23.7483C25.1326 23 26 22.0312 26 20.811C26.0016 20.4331 25.8997 20.0616 25.7047 19.7347L18.4426 7.1035C18.0272 6.37664 17.2705 6 16.5047 6C15.748 6 14.9732 6.37664 14.5574 7.1035L7.30474 19.7435C7.10158 20.0841 7 20.4431 7 20.8114C7 22.0312 7.87681 23 9.25167 23ZM16.5047 16.8548C16.0157 16.8548 15.748 16.5857 15.7295 16.1015L15.6003 11.6699C15.5818 11.1853 15.9693 10.8262 16.4953 10.8262C17.0122 10.8262 17.4181 11.1941 17.3996 11.6787L17.2614 16.1015C17.2429 16.5949 16.9752 16.8548 16.5047 16.8548ZM16.5047 20.1653C15.9693 20.1653 15.4712 19.7526 15.4712 19.1961C15.4712 18.64 15.9602 18.2277 16.5047 18.2277C17.0492 18.2277 17.5382 18.6312 17.5382 19.1961C17.5382 19.7614 17.0398 20.1653 16.5047 20.1653Z",
    fill: "#00368E"
  }))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    id: "comment",
    viewBox: "0 0 13 11",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9707 1.14062C12.9707 0.58834 12.523 0.140625 11.9707 0.140625H1.3877C0.835411 0.140625 0.387695 0.58834 0.387695 1.14062V7.65565V7.65589V9.14362C0.387695 10.0353 1.46652 10.4811 2.096 9.84953L3.98914 7.94998C4.17677 7.76171 4.43164 7.65589 4.69744 7.65589H11.9707C12.523 7.65589 12.9707 7.20817 12.9707 6.65589V1.14062Z",
    fill: "#D9D9D9"
  }))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    id: "nested-arrow",
    viewBox: "0 0 12 13",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6768 11.2588C11.7744 11.1612 11.7744 11.0029 11.6768 10.9053L10.0858 9.31426C9.98816 9.21663 9.82986 9.21663 9.73223 9.31426C9.6346 9.41189 9.6346 9.57019 9.73223 9.66782L11.1464 11.082L9.73223 12.4962C9.6346 12.5939 9.6346 12.7522 9.73223 12.8498C9.82986 12.9474 9.98816 12.9474 10.0858 12.8498L11.6768 11.2588ZM0.25 0.0820312V9.08203H0.75V0.0820312H0.25ZM2.5 11.332H11.5V10.832H2.5V11.332ZM0.25 9.08203C0.25 10.3247 1.25736 11.332 2.5 11.332V10.832C1.5335 10.832 0.75 10.0485 0.75 9.08203H0.25Z",
    fill: "#898989"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    id: "star-circle",
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4455 14.6109L22.0233 18.3866L23.3706 24.0332C23.4449 24.3397 23.4257 24.6612 23.3155 24.9569C23.2053 25.2527 23.009 25.5095 22.7514 25.6949C22.4937 25.8804 22.1863 25.9861 21.868 25.9987C21.5497 26.0114 21.2347 25.9304 20.9629 25.766L16.0002 22.7438L11.0345 25.766C10.7628 25.9294 10.4482 26.0096 10.1304 25.9965C9.81261 25.9834 9.50586 25.8776 9.24876 25.6923C8.99165 25.5071 8.7957 25.2507 8.68556 24.9554C8.57543 24.6602 8.55604 24.3393 8.62984 24.0332L9.98206 18.3866L5.55984 14.6109C5.31937 14.4052 5.14545 14.134 5.05982 13.8311C4.97418 13.5283 4.98062 13.2072 5.07833 12.9079C5.17603 12.6086 5.36068 12.3445 5.6092 12.1484C5.85773 11.9524 6.15911 11.8331 6.47573 11.8055L12.2737 11.3427L14.5104 5.98683C14.6315 5.69494 14.8375 5.44526 15.1024 5.26954C15.3672 5.09382 15.6789 5 15.9977 5C16.3166 5 16.6283 5.09382 16.8931 5.26954C17.158 5.44526 17.364 5.69494 17.4851 5.98683L19.7208 11.3427L25.5188 11.8055C25.836 11.8321 26.1383 11.9507 26.3877 12.1465C26.6371 12.3422 26.8226 12.6065 26.9209 12.9061C27.0193 13.2058 27.026 13.5274 26.9404 13.8309C26.8548 14.1343 26.6805 14.4059 26.4396 14.6118L26.4455 14.6109Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#00368E",
    strokeWidth: 2
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    id: "point-circle-blue",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6472_15146)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11,
    fill: "url(#paint0_radial_6472_15146)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6472_15146)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.4999,
    cy: 11.4994,
    r: 9.12388,
    fill: "url(#paint1_radial_6472_15146)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_6472_15146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.08789 6.76758C8.08789 6.49144 8.31175 6.26758 8.58789 6.26758H11.7354C14.182 6.26758 16.0883 7.10815 16.0883 9.74995C16.0883 12.2867 14.182 13.4274 11.7954 13.4274H10.8094C10.5333 13.4274 10.3094 13.6513 10.3094 13.9274V16.8751C10.3094 17.1513 10.0855 17.3751 9.8094 17.3751H8.58789C8.31175 17.3751 8.08789 17.1513 8.08789 16.8751V6.76758ZM11.6453 11.6713C13.1613 11.6713 13.9118 11.0258 13.9118 9.74995C13.9118 8.44406 13.1163 8.02377 11.5703 8.02377H10.8094C10.5333 8.02377 10.3094 8.24763 10.3094 8.52377V11.1713C10.3094 11.4474 10.5333 11.6713 10.8094 11.6713H11.6453Z",
    fill: "#82B5FF"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6472_15146",
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.508334
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620678 0 0 0 0 0.749007 0 0 0 0 0.991406 0 0 0 0.91 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6472_15146"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6472_15146",
    x: 1.35931,
    y: 1.35882,
    width: 20.2809,
    height: 20.2811,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.508334
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620678 0 0 0 0 0.749007 0 0 0 0 0.991406 0 0 0 0.82 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6472_15146"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6472_15146",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_6472_15146",
    x: 8.08789,
    y: 6.26758,
    width: 8.00049,
    height: 11.1077,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.508334
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.351753 0 0 0 0 0.518816 0 0 0 0 0.834379 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6472_15146"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6472_15146",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6236 11.6236) rotate(77.364) scale(36.0274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79AFFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6472_15146",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6024 11.6019) rotate(85.369) scale(8.4205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF4FF"
  }))))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    id: "comment-circle",
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#00368E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 10C26 9.44772 25.5523 9 25 9H8C7.44772 9 7 9.44771 7 10V20.3086V20.3095V23.7754C7 24.6663 8.07714 25.1125 8.70711 24.4825L12.5872 20.6024C12.7748 20.4149 13.0291 20.3095 13.2943 20.3095H25C25.5523 20.3095 26 19.8618 26 19.3095V10Z",
    fill: "#00368E"
  }))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    id: "point-circle",
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4709 8C17.3865 8 18.242 8.08649 19.0375 8.25946C19.833 8.41802 20.5235 8.69189 21.1088 9.08108C21.6942 9.47027 22.152 9.98919 22.4822 10.6378C22.8274 11.2721 23 12.0649 23 13.0162C23 13.9243 22.8274 14.7171 22.4822 15.3946C22.152 16.0577 21.6942 16.6054 21.1088 17.0378C20.5385 17.4703 19.863 17.7946 19.0826 18.0108C18.3021 18.2126 17.4615 18.3135 16.561 18.3135H14.3321V24H11V8H16.4709ZM16.3358 15.7838C18.6023 15.7838 19.7355 14.8613 19.7355 13.0162C19.7355 12.0793 19.4353 11.4306 18.8349 11.0703C18.2495 10.7099 17.379 10.5297 16.2233 10.5297H14.3321V15.7838H16.3358Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#00368E",
    strokeWidth: 2
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    id: "calendar",
    viewBox: "0 0 19 19",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0409 3.16683H13.4575V2.37516C13.4575 2.1652 13.3741 1.96384 13.2256 1.81537C13.0772 1.6669 12.8758 1.5835 12.6659 1.5835C12.4559 1.5835 12.2545 1.6669 12.1061 1.81537C11.9576 1.96384 11.8742 2.1652 11.8742 2.37516V3.16683H7.12419V2.37516C7.12419 2.1652 7.04078 1.96384 6.89231 1.81537C6.74385 1.6669 6.54248 1.5835 6.33252 1.5835C6.12256 1.5835 5.92119 1.6669 5.77273 1.81537C5.62426 1.96384 5.54085 2.1652 5.54085 2.37516V3.16683H3.95752C3.32763 3.16683 2.72354 3.41705 2.27814 3.86245C1.83274 4.30785 1.58252 4.91194 1.58252 5.54183V15.0418C1.58252 15.6717 1.83274 16.2758 2.27814 16.7212C2.72354 17.1666 3.32763 17.4168 3.95752 17.4168H15.0409C15.6707 17.4168 16.2748 17.1666 16.7202 16.7212C17.1656 16.2758 17.4159 15.6717 17.4159 15.0418V5.54183C17.4159 4.91194 17.1656 4.30785 16.7202 3.86245C16.2748 3.41705 15.6707 3.16683 15.0409 3.16683ZM15.8325 15.0418C15.8325 15.2518 15.7491 15.4532 15.6006 15.6016C15.4522 15.7501 15.2508 15.8335 15.0409 15.8335H3.95752C3.74756 15.8335 3.54619 15.7501 3.39773 15.6016C3.24926 15.4532 3.16585 15.2518 3.16585 15.0418V9.50016H15.8325V15.0418ZM15.8325 7.91683H3.16585V5.54183C3.16585 5.33187 3.24926 5.1305 3.39773 4.98204C3.54619 4.83357 3.74756 4.75016 3.95752 4.75016H5.54085V5.54183C5.54085 5.75179 5.62426 5.95316 5.77273 6.10162C5.92119 6.25009 6.12256 6.3335 6.33252 6.3335C6.54248 6.3335 6.74385 6.25009 6.89231 6.10162C7.04078 5.95316 7.12419 5.75179 7.12419 5.54183V4.75016H11.8742V5.54183C11.8742 5.75179 11.9576 5.95316 12.1061 6.10162C12.2545 6.25009 12.4559 6.3335 12.6659 6.3335C12.8758 6.3335 13.0772 6.25009 13.2256 6.10162C13.3741 5.95316 13.4575 5.75179 13.4575 5.54183V4.75016H15.0409C15.2508 4.75016 15.4522 4.83357 15.6006 4.98204C15.7491 5.1305 15.8325 5.33187 15.8325 5.54183V7.91683Z",
    fill: "#898989"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    id: "horizontal-dot3",
    viewBox: "0 0 19 4",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 2,
    r: 2,
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 2,
    r: 2,
    fill: "#898989"
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    id: "meat-ball",
    width: 18,
    height: 4,
    viewBox: "0 0 18 4",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "rotate(-90 2 2)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 2,
    r: 2,
    transform: "rotate(-90 9 2)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 2,
    r: 2,
    transform: "rotate(-90 16 2)",
    fill: "#898989"
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    id: "middle-dot",
    viewBox: "0 0 5 5",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.49987,
    cy: 2.50049,
    rx: 1.5194,
    ry: 1.52002,
    fill: "#484848"
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    id: "blue-triangle",
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 16L3.93782 5.5L16.0622 5.5L10 16Z",
    fill: "#00368E"
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-circle-grey",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5332,
    cy: 10.8418,
    r: 10.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5332 12.2032L9.34846 16.1419L16.7332 7.34186",
    stroke: "#D9D9D9",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-circle-blue",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 11.3418,
    r: 10.5,
    fill: "#BFD7EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12.4031L8.81526 16.3418L16.2 7.54181",
    stroke: "#5F86BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    id: "comment-bell-fill",
    viewBox: "0 0 17 21",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1.13379 9.70004C1.13379 5.63154 4.43196 2.33337 8.50046 2.33337C12.569 2.33337 15.8671 5.63154 15.8671 9.70004V12.9999C15.8671 13.5522 15.4194 13.9999 14.8671 13.9999H2.13379C1.5815 13.9999 1.13379 13.5522 1.13379 12.9999V9.70004Z",
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    y: 13.9996,
    width: 17,
    height: 3.49996,
    rx: 1.74998,
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.7998,
    y: 17.5001,
    width: 3.4,
    height: 3.49996,
    rx: 1.7,
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.7998,
    width: 3.4,
    height: 3.49996,
    rx: 1.7,
    fill: "#00368E"
  }))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    id: "comment-bell",
    viewBox: "0 0 20 21",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M2.63379 9.70004C2.63379 5.63154 5.93196 2.33337 10.0005 2.33337C14.069 2.33337 17.3671 5.63154 17.3671 9.70004V12.9999C17.3671 13.5522 16.9194 13.9999 16.3671 13.9999H3.63379C3.0815 13.9999 2.63379 13.5522 2.63379 12.9999V9.70004Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 1.5,
    y: 13.9996,
    width: 17,
    height: 3.49996,
    rx: 1.74998,
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.2998,
    y: 17.5001,
    width: 3.4,
    height: 3.49996,
    rx: 1.7,
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.2998,
    width: 3.4,
    height: 3.49996,
    rx: 1.7,
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 1.50012L1 19.4998",
    stroke: "#898989",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    id: "host",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33337 1H10.1107C10.9391 1 11.6107 1.67157 11.6107 2.5V14H2.83337V2.5L2.84119 2.34668C2.91798 1.59028 3.55671 1 4.33337 1Z",
    stroke: "#484848",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6665 5.66675C14.4949 5.66675 15.1665 6.33832 15.1665 7.16675V13.9998H11.7222V5.66675H13.6665Z",
    stroke: "#484848",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 14.0333H17",
    stroke: "#484848",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8.46667H8.44434C8.72048 8.46667 8.94434 8.69053 8.94434 8.96667V13.9999H5.5V8.96667C5.5 8.69053 5.72386 8.46667 6 8.46667Z",
    stroke: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91113 3.57996H6.06669",
    stroke: "#484848",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91113 5.91345H6.06669",
    stroke: "#484848",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46655 3.57996H9.62211",
    stroke: "#484848",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46655 5.91345H9.62211",
    stroke: "#484848",
    strokeLinecap: "round"
  }))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    id: "report-comment",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3 21C9.06131 21 8.83239 20.9052 8.6636 20.7364C8.49482 20.5676 8.4 20.3387 8.4 20.1V17.4H4.8C4.32261 17.4 3.86477 17.2104 3.52721 16.8728C3.18964 16.5352 3 16.0774 3 15.6V4.8C3 4.32261 3.18964 3.86477 3.52721 3.52721C3.86477 3.18964 4.32261 3 4.8 3H19.2C19.6774 3 20.1352 3.18964 20.4728 3.52721C20.8104 3.86477 21 4.32261 21 4.8V15.6C21 16.0774 20.8104 16.5352 20.4728 16.8728C20.1352 17.2104 19.6774 17.4 19.2 17.4H13.71L10.38 20.739C10.2 20.91 9.975 21 9.75 21H9.3Z",
    fill: "#5F86BF"
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    id: "report-user",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.31226,
    cy: 4.16675,
    r: 4.16675,
    fill: "#5F86BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.5223C0 11.4417 3.30801 8.13367 7.38864 8.13367H9.23579C13.3164 8.13367 16.6244 11.4417 16.6244 15.5223C16.6244 16.3384 15.9628 17 15.1467 17H1.47773C0.661602 17 0 16.3384 0 15.5223Z",
    fill: "#5F86BF"
  }))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    id: "comment-exclamation-question-mark",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.04018 1C3.96866 1 2.94102 1.41003 2.18334 2.13988C1.42566 2.86973 1 3.85963 1 4.89179V10.9319C1 11.964 1.42566 12.9539 2.18334 13.6838C2.94102 14.4136 3.96866 14.8236 5.04018 14.8236H5.13411V18.5131C5.13402 18.6077 5.16255 18.7002 5.21622 18.7794C5.26989 18.8586 5.34636 18.921 5.43628 18.959C5.5262 18.997 5.62566 19.0089 5.72251 18.9933C5.81935 18.9777 5.90936 18.9352 5.98154 18.8711L10.5469 14.8236H14.9598C16.0313 14.8236 17.059 14.4136 17.8167 13.6838C18.5743 12.9539 19 11.964 19 10.9319V4.89179C19 3.85963 18.5743 2.86973 17.8167 2.13988C17.059 1.41003 16.0313 1 14.9598 1H5.04018Z",
    fill: "#EAF5FD",
    stroke: "#5F86BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61328 4.85693V8.00345V4.85693Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61328 4.85693V8.00345",
    stroke: "#5F86BF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61377 9.96875C6.7463 9.96884 6.854 10.0764 6.854 10.209C6.85391 10.3415 6.74624 10.4491 6.61377 10.4492C6.48122 10.4492 6.37363 10.3415 6.37354 10.209C6.37354 10.0764 6.48116 9.96875 6.61377 9.96875Z",
    fill: "black",
    stroke: "#5F86BF",
    strokeWidth: 0.8085
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6479 9.96875C12.7805 9.96884 12.8882 10.0764 12.8882 10.209C12.8881 10.3415 12.7804 10.4491 12.6479 10.4492C12.5154 10.4492 12.4078 10.3415 12.4077 10.209C12.4077 10.0764 12.5153 9.96875 12.6479 9.96875Z",
    fill: "black",
    stroke: "#5F86BF",
    strokeWidth: 0.8085
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2139 6.3055C11.2138 6.07971 11.268 5.85715 11.3717 5.65622C11.4755 5.45529 11.626 5.28175 11.8107 5.14995C11.9954 5.01814 12.209 4.93185 12.434 4.89821C12.6589 4.86457 12.8887 4.88454 13.1044 4.95647C13.32 5.0284 13.5153 5.15022 13.6741 5.31188C13.833 5.47354 13.9507 5.67039 14.0178 5.88616C14.0848 6.10193 14.0991 6.33043 14.0595 6.55279C14.02 6.77514 13.9277 6.98495 13.7903 7.1649C13.7368 7.22374 13.6801 7.27954 13.6203 7.33204C13.5714 7.37316 13.5475 7.39003 13.4997 7.4222L12.9796 7.77808C12.8511 7.86589 12.746 7.98345 12.6734 8.12059C12.6008 8.25774 12.563 8.41035 12.5632 8.56526",
    stroke: "#5F86BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    id: "dollar-circle",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z",
    fill: "#EAF5FD",
    stroke: "#5F86BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3148 7.80128C12.3148 7.80128 12.024 6.42627 10.0004 6.27666M10.0004 6.27666V4.93018M10.0004 6.27666C9.87827 6.26813 9.75584 6.26375 9.63337 6.26355C8.75422 6.26355 7.61133 6.99617 7.61133 8.01799C7.61133 9.04057 8.43881 9.44159 9.89788 9.69068C11.357 9.93977 12.3888 10.4889 12.3888 11.6163C12.3888 12.7438 11.1811 13.2366 10.167 13.2366C10.1115 13.2368 10.0559 13.2355 10.0004 13.2327M7.72006 11.7582C7.72006 11.7582 8.30693 13.1463 10.0004 13.2327M10.0004 13.2327V14.5699",
    stroke: "#5F86BF",
    strokeLinecap: "round"
  }))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    id: "camera-blue-stroke",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8338 1H9.16616C8.50357 1 8.17178 1 7.87114 1.09068C7.60454 1.17075 7.35643 1.30292 7.14141 1.47753C6.89816 1.67529 6.71524 1.94927 6.34746 2.49625L5.23535 4.14976C3.75254 4.14976 3.01114 4.14976 2.44486 4.43531C1.94695 4.68732 1.54231 5.0892 1.28897 5.5833C1 6.1438 1 6.8789 1 8.34911V13.8006C1 15.2709 1 16.006 1.28897 16.5674C1.54195 17.0613 1.94768 17.4627 2.44486 17.7144C3.01114 18 3.75254 18 5.23535 18H14.7646C16.2475 18 16.9889 18 17.5551 17.7144C18.0531 17.4624 18.4577 17.0606 18.711 16.5665C19 16.006 19 15.2709 19 13.8006V8.34911C19 6.8789 19 6.1438 18.711 5.58234C18.4575 5.08859 18.0529 4.68707 17.5551 4.43531C16.9889 4.14976 16.2475 4.14976 14.7646 4.14976L13.6525 2.49625C13.2848 1.94927 13.1009 1.67626 12.8586 1.47753C12.643 1.30275 12.3952 1.17134 12.1289 1.09068C11.8282 1 11.4964 1 10.8338 1Z",
    fill: "#EAF5FD",
    stroke: "#5F86BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6731 10.6691C13.6731 11.1473 13.5781 11.6209 13.3935 12.0627C13.2089 12.5046 12.9384 12.906 12.5973 13.2442C12.2562 13.5824 11.8513 13.8506 11.4057 14.0336C10.9601 14.2167 10.4825 14.3109 10.0001 14.3109C9.51778 14.3109 9.04016 14.2167 8.59454 14.0336C8.14891 13.8506 7.744 13.5824 7.40294 13.2442C7.06187 12.906 6.79132 12.5046 6.60674 12.0627C6.42215 11.6209 6.32715 11.1473 6.32715 10.6691C6.32715 9.70324 6.71412 8.77695 7.40294 8.09399C8.09175 7.41103 9.02599 7.02734 10.0001 7.02734C10.9743 7.02734 11.9085 7.41103 12.5973 8.09399C13.2861 8.77695 13.6731 9.70324 13.6731 10.6691Z",
    stroke: "#5F86BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    id: "x-shield",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.78892V5.15392C17.5 4.32492 16.867 3.63292 16.047 3.50992C15.096 3.36792 13.867 3.13392 12.969 2.78793C12.062 2.43893 10.972 1.78092 10.207 1.28292C9.92198 1.09826 9.58962 1 9.25 1C8.91038 1 8.57802 1.09826 8.293 1.28292C7.529 1.78092 6.438 2.43893 5.531 2.78793C4.632 3.13392 3.404 3.36792 2.453 3.50992C1.633 3.63292 1 4.32492 1 5.15392V8.78892C0.999867 10.6251 1.49879 12.4267 2.44343 14.0012C3.38806 15.5757 4.74287 16.8639 6.363 17.7279L6.593 17.8509L8.555 18.7969C8.77177 18.9015 9.00934 18.9558 9.25 18.9558C9.49066 18.9558 9.72823 18.9015 9.945 18.7969L11.906 17.8509L12.136 17.7279C13.7563 16.864 15.1113 15.5759 16.0561 14.0014C17.001 12.4269 17.5 10.6252 17.5 8.78892ZM6.75 7.38192L11.75 12.3819L6.75 7.38192ZM11.75 7.38192L6.75 12.3819L11.75 7.38192Z",
    fill: "#EAF5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7.38192L11.75 12.3819M11.75 7.38192L6.75 12.3819M17.5 8.78892V5.15392C17.5 4.32492 16.867 3.63292 16.047 3.50992C15.096 3.36792 13.867 3.13392 12.969 2.78793C12.062 2.43892 10.972 1.78092 10.207 1.28292C9.92198 1.09826 9.58962 1 9.25 1C8.91038 1 8.57802 1.09826 8.293 1.28292C7.529 1.78092 6.438 2.43892 5.531 2.78793C4.632 3.13392 3.404 3.36792 2.453 3.50992C1.633 3.63292 1 4.32492 1 5.15392V8.78892C0.999867 10.6251 1.49879 12.4267 2.44343 14.0012C3.38806 15.5757 4.74287 16.8639 6.363 17.7279L6.593 17.8509L8.555 18.7969C8.77177 18.9015 9.00934 18.9558 9.25 18.9558C9.49066 18.9558 9.72823 18.9015 9.945 18.7969L11.906 17.8509L12.136 17.7279C13.7563 16.864 15.1113 15.5759 16.0561 14.0014C17.001 12.4269 17.5 10.6252 17.5 8.78892Z",
    stroke: "#5F86BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    id: "traffic-cone",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "#EAF5FD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.07275 1.38184L3.18896 18.5287H16.8055L11.0899 1.38184H9.07275Z",
    fill: "#EAF5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 19H19",
    stroke: "#5F86BF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.94604 19L4.40745 14.5M4.40745 14.5L5.86886 10M4.40745 14.5H15.5927M17.0542 19L15.5927 14.5M15.5927 14.5L14.1313 10M5.86886 10L7.32929 5.5L8.57275 1.67232C8.63618 1.47707 8.75976 1.30689 8.92578 1.18613C9.09181 1.06537 9.29177 1.00022 9.49707 1H10.5022C10.7076 1.00001 10.9078 1.06507 11.074 1.18584C11.2402 1.30662 11.364 1.47691 11.4275 1.67232L12.6709 5.5L14.1313 10M5.86886 10H14.1313",
    stroke: "#5F86BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    id: "hand-stop",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 8.9917V12.5996C1 14.5522 1 15.5289 1.234 16.3256C1.79199 18.2222 3.28281 19.7143 5.18867 20.3781C5.82396 20.5636 6.45502 20.7606 7.67054 20.9387C8.37999 21.0395 9.10169 21.016 9.80299 20.8692C10.1238 20.8038 10.3853 20.748 10.6056 20.7006C11.1244 20.5889 11.6432 20.4551 12.1197 20.2222C12.6576 19.9609 13.0758 19.689 13.6814 19.2391C14.0435 18.9704 14.375 18.6427 15.0367 17.9873L18.4747 14.5838C18.6412 14.4192 18.7733 14.2235 18.8634 14.008C18.9536 13.7924 19 13.5612 19 13.3277C19 13.0942 18.9536 12.8631 18.8634 12.6475C18.7733 12.4319 18.6412 12.2362 18.4747 12.0717C18.1375 11.7384 17.6815 11.5513 17.2062 11.5513C16.731 11.5513 16.275 11.7384 15.9378 12.0717L13.5554 14.431V8.9917",
    fill: "#EAF5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 8.9917V12.5996C1 14.5522 1 15.5289 1.234 16.3256C1.79199 18.2222 3.28281 19.7143 5.18867 20.3781C5.82396 20.5636 6.45502 20.7606 7.67054 20.9387C8.37999 21.0395 9.10169 21.016 9.80299 20.8692C10.1238 20.8038 10.3853 20.748 10.6056 20.7006C11.1244 20.5889 11.6432 20.4551 12.1197 20.2222C12.6576 19.9609 13.0758 19.689 13.6814 19.2391C14.0435 18.9704 14.375 18.6427 15.0367 17.9873L18.4747 14.5838C18.6412 14.4192 18.7733 14.2235 18.8634 14.008C18.9536 13.7924 19 13.5612 19 13.3277C19 13.0942 18.9536 12.8631 18.8634 12.6475C18.7733 12.4319 18.6412 12.2362 18.4747 12.0717C18.1375 11.7384 17.6815 11.5513 17.2062 11.5513C16.731 11.5513 16.275 11.7384 15.9378 12.0717L13.5554 14.431V8.9917",
    stroke: "#5F86BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.416 6.66582V4.66166C10.416 3.80288 11.1191 3.10743 11.9863 3.10743C12.8524 3.10743 13.5554 3.80288 13.5554 4.66166V9.32329M7.27771 8.98716V2.55423C7.27771 1.69545 7.98077 1 8.84688 1C9.71405 1 10.416 1.69545 10.416 2.55423V8.99137M4.13833 6.10525V8.99137V3.61321C4.14896 3.20593 4.319 2.81889 4.61222 2.53457C4.90543 2.25024 5.29863 2.09113 5.70802 2.09113C6.11741 2.09113 6.51061 2.25024 6.80383 2.53457C7.09704 2.81889 7.26708 3.20593 7.27771 3.61321V8.99137M4.13833 7.72164V6.76909C4.13833 5.91031 3.43633 5.21486 2.56916 5.21486C1.70305 5.21486 1 5.91031 1 6.76909V9.65416",
    fill: "#EAF5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.416 6.66582V4.66166C10.416 3.80288 11.1191 3.10743 11.9863 3.10743C12.8524 3.10743 13.5554 3.80288 13.5554 4.66166V9.32329M7.27771 8.98716V2.55423C7.27771 1.69545 7.98077 1 8.84688 1C9.71405 1 10.416 1.69545 10.416 2.55423V8.99137M4.13833 6.10525V8.99137V3.61321C4.14896 3.20593 4.319 2.81889 4.61222 2.53457C4.90543 2.25024 5.29863 2.09113 5.70802 2.09113C6.11741 2.09113 6.51061 2.25024 6.80383 2.53457C7.09704 2.81889 7.26708 3.20593 7.27771 3.61321V8.99137M4.13833 7.72164V6.76909C4.13833 5.91031 3.43633 5.21486 2.56916 5.21486C1.70305 5.21486 1 5.91031 1 6.76909V9.65416",
    stroke: "#5F86BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    id: "list-x-circle",
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 5H6.59459H1ZM3.80703 9.62162H8.2973H3.80703ZM6.61405 14.2432H9.98054H6.61405Z",
    fill: "#EAF5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 5H6.59459M3.80703 9.62162H8.2973M6.61405 14.2432H9.98054",
    stroke: "#5F86BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.1943,
    cy: 5,
    r: 4.5,
    fill: "#EAF5FD",
    stroke: "#5F86BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8674 3.51648L12.5213 6.48361",
    stroke: "#5F86BF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5213 3.51648L15.8674 6.48361",
    stroke: "#5F86BF",
    strokeLinecap: "round"
  }))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    id: "sad-face",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z",
    fill: "#EAF5FD",
    stroke: "#5F86BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08057 6.85156C7.47599 6.85156 7.79715 7.17201 7.79736 7.56738C7.79736 7.96294 7.47612 8.28418 7.08057 8.28418C6.68519 8.28397 6.36475 7.96281 6.36475 7.56738C6.36496 7.17214 6.68533 6.85178 7.08057 6.85156Z",
    fill: "#5F86BF",
    stroke: "#5F86BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9185 6.85156C13.3139 6.85156 13.635 7.17201 13.6353 7.56738C13.6353 7.96294 13.314 8.28418 12.9185 8.28418C12.5231 8.28397 12.2026 7.96281 12.2026 7.56738C12.2029 7.17214 12.5232 6.85178 12.9185 6.85156Z",
    fill: "#5F86BF",
    stroke: "#5F86BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3704 13.7099C13.0288 13.1183 12.5375 12.6271 11.9459 12.2855C11.3543 11.944 10.6832 11.7642 10 11.7642C9.31688 11.7642 8.64578 11.944 8.05416 12.2855C7.46253 12.6271 6.97124 13.1183 6.62964 13.7099",
    fill: "#EAF5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3704 13.7099C13.0288 13.1183 12.5375 12.6271 11.9459 12.2855C11.3543 11.944 10.6832 11.7642 10 11.7642C9.31688 11.7642 8.64578 11.944 8.05416 12.2855C7.46253 12.6271 6.97124 13.1183 6.62964 13.7099",
    stroke: "#5F86BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    id: "user-question-mark",
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.04043 16.0338H1.84115C1.61806 16.0338 1.40411 15.9432 1.24637 15.7821C1.08862 15.621 1 15.4025 1 15.1747V14.1043C1 11.6937 4.34273 9.80548 7.7292 9.80548C7.94622 9.80548 8.16212 9.81322 8.37689 9.82868M10.7607 4.09609C10.7607 4.50268 10.6823 4.90528 10.53 5.28092C10.3776 5.65655 10.1543 5.99786 9.8728 6.28536C9.5913 6.57286 9.25711 6.80092 8.88931 6.95651C8.52151 7.11211 8.12731 7.19219 7.7292 7.19219C7.3311 7.19219 6.9369 7.11211 6.5691 6.95651C6.2013 6.80092 5.86711 6.57286 5.58561 6.28536C5.3041 5.99786 5.0808 5.65655 4.92846 5.28092C4.77611 4.90528 4.6977 4.50268 4.6977 4.09609C4.6977 3.27496 5.01709 2.48746 5.58561 1.90683C6.15412 1.32619 6.9252 1 7.7292 1C8.53321 1 9.30429 1.32619 9.8728 1.90683C10.4413 2.48746 10.7607 3.27496 10.7607 4.09609Z",
    stroke: "#5F86BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.3246,
    cy: 12.3246,
    r: 4.17535,
    fill: "#EAF5FD",
    stroke: "#5F86BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3249 14.1713C14.4041 14.1714 14.4684 14.2357 14.4684 14.3149C14.4684 14.394 14.404 14.4584 14.3249 14.4584C14.2457 14.4584 14.1814 14.3941 14.1813 14.3149C14.1813 14.2356 14.2456 14.1713 14.3249 14.1713Z",
    fill: "#5F86BF",
    stroke: "#5F86BF",
    strokeWidth: 0.8085
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1059 10.9965C13.1058 10.8046 13.1518 10.6154 13.2401 10.4446C13.3283 10.2738 13.4562 10.1263 13.6132 10.0142C13.7702 9.9022 13.9518 9.82885 14.1431 9.80025C14.3343 9.77165 14.5296 9.78862 14.7129 9.84977C14.8962 9.91091 15.0622 10.0145 15.1973 10.1519C15.3323 10.2893 15.4324 10.4566 15.4894 10.6401C15.5463 10.8235 15.5585 11.0177 15.5249 11.2067C15.4912 11.3958 15.4128 11.5741 15.296 11.7271C15.2505 11.7771 15.2023 11.8245 15.1515 11.8692C15.1099 11.9041 15.0896 11.9185 15.049 11.9458L14.6069 12.2483C14.4976 12.323 14.4082 12.4229 14.3466 12.5395C14.2849 12.6561 14.2527 12.7858 14.2529 12.9175",
    stroke: "#5F86BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    id: "question-mark-circle",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z",
    fill: "#EAF5FD",
    stroke: "#5F86BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37394 7.77091C7.3739 7.35424 7.47301 6.94354 7.66308 6.57274C7.85315 6.20194 8.12873 5.8817 8.46704 5.63846C8.80535 5.39523 9.19669 5.23599 9.60871 5.17391C10.0207 5.11182 10.4416 5.14867 10.8366 5.28141C11.2315 5.41415 11.5893 5.63898 11.8802 5.9373C12.1711 6.23562 12.3868 6.59889 12.5095 6.99707C12.6323 7.39526 12.6585 7.81693 12.586 8.22726C12.5136 8.63759 12.3445 9.02479 12.0929 9.35686C11.995 9.46544 11.891 9.56841 11.7815 9.66529C11.692 9.74119 11.6482 9.77232 11.5606 9.83167L10.6081 10.4884C10.3726 10.6505 10.1801 10.8674 10.0472 11.1205C9.91429 11.3736 9.845 11.6552 9.84529 11.9411",
    stroke: "#5F86BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83233 14.1389C10.0934 14.1389 10.3058 14.3505 10.306 14.6116C10.306 14.8728 10.0936 15.0852 9.83233 15.0852C9.57126 15.085 9.35968 14.8727 9.35968 14.6116C9.35985 14.3506 9.57137 14.1391 9.83233 14.1389Z",
    fill: "black",
    stroke: "#5F86BF"
  }))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    id: "skull-face",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8281 15.1412C17.993 13.6545 19 11.7922 19 9.14378C19 4.64865 14.9709 1 10 1C5.02908 1 1 4.64865 1 9.14378C1 11.7922 2.39816 13.6545 4.564 15.1412C4.39373 15.7347 4.43557 17.3314 4.74595 17.8461C5.14876 18.5145 5.932 19 6.56541 19C7.28832 19 7.92368 18.5388 8.2827 17.8461C8.6427 18.5388 9.27708 19 10 19C10.7229 19 11.3583 18.5398 11.7173 17.8461C12.0773 18.5398 12.7117 19 13.4346 19C14.068 19 14.8493 18.5145 15.3222 17.8461C15.6861 17.3314 15.8281 15.7347 15.8281 15.1412Z",
    fill: "#EAF5FD",
    stroke: "#5F86BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91892 8.2973C3.91892 7.65218 4.17519 7.03348 4.63136 6.57731C5.08753 6.12114 5.70623 5.86487 6.35135 5.86487C6.99647 5.86487 7.61517 6.12114 8.07134 6.57731C8.52751 7.03348 8.78378 7.65218 8.78378 8.2973V9.27028C8.78378 9.65735 8.63002 10.0286 8.35632 10.3023C8.08262 10.576 7.7114 10.7297 7.32432 10.7297H6.35135C5.70623 10.7297 5.08753 10.4735 4.63136 10.0173C4.17519 9.56112 3.91892 8.94242 3.91892 8.2973ZM11.2162 8.2973C11.2162 7.81621 11.3589 7.34593 11.6262 6.94591C11.8934 6.5459 12.2733 6.23413 12.7178 6.05003C13.1623 5.86592 13.6513 5.81775 14.1232 5.91161C14.595 6.00546 15.0285 6.23713 15.3686 6.57731C15.7088 6.91749 15.9405 7.35091 16.0343 7.82276C16.1282 8.2946 16.08 8.78368 15.8959 9.22815C15.7118 9.67262 15.4 10.0525 15 10.3198C14.6 10.5871 14.1297 10.7297 13.6486 10.7297H12.6757C12.2886 10.7297 11.9174 10.576 11.6437 10.3023C11.37 10.0286 11.2162 9.65735 11.2162 9.27028V8.2973ZM9.49113 11.1481L8.30022 13.2653C8.25028 13.3541 8.22447 13.4545 8.22535 13.5564C8.22623 13.6583 8.25377 13.7582 8.30522 13.8461C8.35668 13.9341 8.43026 14.0071 8.51866 14.0578C8.60705 14.1085 8.70718 14.1351 8.80908 14.1351H11.1909C11.2928 14.1351 11.3929 14.1085 11.4813 14.0578C11.5697 14.0071 11.6433 13.9341 11.6948 13.8461C11.7462 13.7582 11.7738 13.6583 11.7746 13.5564C11.7755 13.4545 11.7497 13.3541 11.6998 13.2653L10.5089 11.1481C10.4581 11.0578 10.3842 10.9826 10.2948 10.9303C10.2053 10.878 10.1036 10.8504 10 10.8504C9.8964 10.8504 9.79466 10.878 9.70523 10.9303C9.61581 10.9826 9.54191 11.0578 9.49113 11.1481Z",
    fill: "#5F86BF"
  }))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    id: "host",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33337 1H10.1107C10.9391 1 11.6107 1.67157 11.6107 2.5V14H2.83337V2.5L2.84119 2.34668C2.91798 1.59028 3.55671 1 4.33337 1Z",
    stroke: "#484848",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6665 5.66675C14.4949 5.66675 15.1665 6.33832 15.1665 7.16675V13.9998H11.7222V5.66675H13.6665Z",
    stroke: "#484848",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 14.0333H17",
    stroke: "#484848",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8.46667H8.44434C8.72048 8.46667 8.94434 8.69053 8.94434 8.96667V13.9999H5.5V8.96667C5.5 8.69053 5.72386 8.46667 6 8.46667Z",
    stroke: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91113 3.57996H6.06669",
    stroke: "#484848",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91113 5.91345H6.06669",
    stroke: "#484848",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46655 3.57996H9.62211",
    stroke: "#484848",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46655 5.91345H9.62211",
    stroke: "#484848",
    strokeLinecap: "round"
  }))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    id: "like",
    viewBox: "0 0 12 10",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.3263 9.53142C5.94436 9.8803 5.35939 9.8803 4.97745 9.53142L4.86351 9.42734C2.06344 6.87965 0.214844 5.19392 0.214844 3.13721C0.214844 1.45148 1.53061 0.136719 3.20521 0.136719C3.9498 0.136719 4.67082 0.410453 5.23307 0.864828C5.47187 1.05782 5.83188 1.05782 6.07069 0.864828C6.63293 0.410453 7.35395 0.136719 8.09854 0.136719C9.77315 0.136719 11.0889 1.45148 11.0889 3.13721C11.0889 5.19392 9.24032 6.87965 6.44025 9.42734L6.3263 9.53142Z"
  }))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    id: "bookmark-fill",
    viewBox: "0 0 14 18",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 18V2C0 1.45 0.196 0.979333 0.588 0.588C0.98 0.196667 1.45067 0.000666667 2 0H12C12.55 0 13.021 0.196 13.413 0.588C13.805 0.98 14.0007 1.45067 14 2V18L7 15L0 18Z"
  }))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    id: "blue-camera",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#00368E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2 8.11111H9L10.2 7H13.8L15 8.11111H16.8C17.1183 8.11111 17.4235 8.22817 17.6485 8.43655C17.8736 8.64492 18 8.92754 18 9.22222V15.8889C18 16.1836 17.8736 16.4662 17.6485 16.6746C17.4235 16.8829 17.1183 17 16.8 17H7.2C6.88174 17 6.57652 16.8829 6.35147 16.6746C6.12643 16.4662 6 16.1836 6 15.8889V9.22222C6 8.92754 6.12643 8.64492 6.35147 8.43655C6.57652 8.22817 6.88174 8.11111 7.2 8.11111ZM12 9.77778C11.2044 9.77778 10.4413 10.0704 9.87868 10.5914C9.31607 11.1123 9 11.8188 9 12.5556C9 13.2923 9.31607 13.9988 9.87868 14.5197C10.4413 15.0407 11.2044 15.3333 12 15.3333C12.7956 15.3333 13.5587 15.0407 14.1213 14.5197C14.6839 13.9988 15 13.2923 15 12.5556C15 11.8188 14.6839 11.1123 14.1213 10.5914C13.5587 10.0704 12.7956 9.77778 12 9.77778ZM12 10.8889C12.4774 10.8889 12.9352 11.0645 13.2728 11.377C13.6104 11.6896 13.8 12.1135 13.8 12.5556C13.8 12.9976 13.6104 13.4215 13.2728 13.7341C12.9352 14.0466 12.4774 14.2222 12 14.2222C11.5226 14.2222 11.0648 14.0466 10.7272 13.7341C10.3896 13.4215 10.2 12.9976 10.2 12.5556C10.2 12.1135 10.3896 11.6896 10.7272 11.377C11.0648 11.0645 11.5226 10.8889 12 10.8889Z",
    fill: "#EAF5FD"
  }))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    id: "ban",
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    fill: "#F0F0F0",
    stroke: "#898989",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3L4 14",
    stroke: "#898989",
    strokeWidth: 2
  }))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    id: "flag",
    viewBox: "0 0 23 22",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0V22",
    stroke: "#898989",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 21,
    height: 14,
    fill: "#F0F0F0"
  }))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    id: "flag-blue",
    viewBox: "0 0 16 18",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1V17",
    stroke: "#898989",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 13,
    height: 10,
    rx: 1,
    fill: "#5F86BF"
  }))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    id: "flag-pink",
    viewBox: "0 0 19 22",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20.18V1.29178C0 0.578515 0.578515 0 1.29178 0C2.00505 0 2.58357 0.578515 2.58357 1.29178V20.18C2.58357 20.8933 2.00505 21.4718 1.29178 21.4718C0.578515 21.4718 0 20.8933 0 20.18Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65308 3.76365C3.65308 3.05038 4.23129 2.47217 4.94456 2.47217H17.7085C18.4218 2.47217 19 3.05039 19 3.76365V12.986C19 13.6993 18.4218 14.2775 17.7085 14.2775H4.94456C4.2313 14.2775 3.65308 13.6993 3.65308 12.986V3.76365Z",
    fill: "#FF849A"
  }))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    id: "adult",
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    fill: "#F0F0F0",
    stroke: "#898989",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.241 12H6.395V7.05C6.116 7.194 5.747 7.338 5.495 7.446V6.654C5.855 6.474 6.296 6.249 6.692 6.024H7.241V12ZM9.18159 12.333L8.83959 11.577C9.93759 11.082 10.8286 10.416 11.1436 9.255C10.7836 9.615 10.3336 9.804 9.79359 9.804C8.74059 9.804 8.03859 8.94 8.03859 7.878C8.03859 6.771 8.83959 5.916 9.93759 5.916C11.3146 5.916 12.1246 7.05 12.1246 8.301C12.1246 10.209 10.8016 11.676 9.18159 12.333ZM9.97359 9.048C10.5046 9.048 11.0176 8.76 11.2696 8.292C11.2696 7.464 10.9186 6.672 10.0096 6.672C9.32559 6.672 8.90259 7.212 8.90259 7.896C8.90259 8.562 9.30759 9.048 9.97359 9.048Z",
    fill: "#898989"
  }))), _symbol92 || (_symbol92 = /*#__PURE__*/React.createElement("symbol", {
    id: "clip-board-list",
    viewBox: "0 0 18 19",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 12,
    height: 1,
    fill: "#5F86BF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 7,
    height: 2,
    fill: "#5F86BF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 9.5,
    width: 12,
    height: 1,
    fill: "#5F86BF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13,
    width: 12,
    height: 1,
    fill: "#5F86BF"
  }))), _symbol93 || (_symbol93 = /*#__PURE__*/React.createElement("symbol", {
    id: "closed-eye",
    viewBox: "0 0 24 24",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.86667C15.1282 6.86667 17.9492 8.50542 19.5648 11.1612C19.8783 11.6767 19.8783 12.3233 19.5649 12.8389C17.9506 15.4946 15.1364 17.1333 12 17.1333C8.86358 17.1333 6.04938 15.4946 4.43508 12.8389C4.12171 12.3233 4.12168 11.6767 4.43524 11.1612C6.05084 8.50542 8.8718 6.86667 12 6.86667ZM12 5C7.72058 5 4.02939 7.57284 2.29954 11.2932C2.09117 11.7413 2.09117 12.2587 2.29954 12.7068C4.02939 16.4272 7.72058 19 12 19C16.2794 19 19.9706 16.4272 21.7005 12.7068C21.9088 12.2587 21.9088 11.7413 21.7005 11.2932C19.9706 7.57284 16.2794 5 12 5ZM12 9.66667C13.2545 9.66667 14.2727 10.712 14.2727 12C14.2727 13.288 13.2545 14.3333 12 14.3333C10.7455 14.3333 9.72727 13.288 9.72727 12C9.72727 10.712 10.7455 9.66667 12 9.66667ZM12 7.8C9.74545 7.8 7.90909 9.68533 7.90909 12C7.90909 14.3147 9.74545 16.2 12 16.2C14.2545 16.2 16.0909 14.3147 16.0909 12C16.0909 9.68533 14.2545 7.8 12 7.8Z"
  }))), _symbol94 || (_symbol94 = /*#__PURE__*/React.createElement("symbol", {
    id: "opened-eye",
    viewBox: "0 0 24 24",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0006 5C16.3424 5.00016 20.088 7.56881 21.8463 11.2842C22.0607 11.7373 22.0607 12.2627 21.8463 12.7158C20.088 16.4312 16.3424 18.9998 12.0006 19C7.65865 19 3.91226 16.4313 2.15392 12.7158C1.93958 12.2628 1.93958 11.7372 2.15392 11.2842C3.91226 7.5687 7.65865 5 12.0006 5ZM12.0006 9.66699C10.7267 9.66699 9.692 10.712 9.692 12C9.692 13.288 10.7267 14.333 12.0006 14.333C13.2743 14.3328 14.3082 13.2879 14.3082 12C14.3082 10.7121 13.2743 9.66721 12.0006 9.66699Z"
  }))), _symbol95 || (_symbol95 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-left",
    viewBox: "0 0 19 17",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.356659 7.50336C-0.118886 7.98925 -0.118886 8.76612 0.356659 9.25201L7.33262 16.3797C7.8155 16.8731 8.60691 16.8816 9.10028 16.3987C9.59366 15.9158 9.60218 15.1244 9.1193 14.631L4.22268 9.62793H17.3436C18.0339 9.62793 18.5936 9.06829 18.5936 8.37793C18.5936 7.68757 18.0339 7.12793 17.3436 7.12793H4.22221L9.1193 2.12432C9.60218 1.63095 9.59366 0.839535 9.10028 0.35666C8.6069 -0.126216 7.81549 -0.117702 7.33262 0.375676L0.356659 7.50336Z"
  }))), _symbol96 || (_symbol96 = /*#__PURE__*/React.createElement("symbol", {
    id: "black-cloud",
    viewBox: "0 0 28 18",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4033 0.40625C24.1511 0.406502 28 4.22072 28 8.92578C28 13.6309 24.1511 17.4451 19.4033 17.4453C17.356 17.4453 15.4765 16.7348 14 15.5508C12.5235 16.7348 10.644 17.4453 8.59668 17.4453C3.84883 17.4451 0 13.6309 0 8.92578C2.96442e-05 4.22068 3.84885 0.406424 8.59668 0.40625C10.6438 0.40625 12.5236 1.116 14 2.2998C15.4764 1.11604 17.3563 0.40625 19.4033 0.40625Z",
    fill: "url(#paint0_radial_5608_23501)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5608_23501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19 9.40625) rotate(90) scale(14 23.0057)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232323"
  }))))), _symbol97 || (_symbol97 = /*#__PURE__*/React.createElement("symbol", {
    id: "movie",
    viewBox: "0 0 15 16",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5161 0.837545C13.0211 0.757875 13.5169 1.07114 13.654 1.57463L14.0656 3.08699L14.0878 3.18717C14.1658 3.65709 13.9005 4.11781 13.4546 4.28534L13.3558 4.31645L2.2163 7.25462L2.11493 7.27631C1.64355 7.35088 1.18001 7.08235 1.00877 6.63692L0.976173 6.53947L0.564504 5.02712C0.427428 4.52352 0.698468 4.00794 1.17642 3.82852L1.27523 3.79741L12.4148 0.859234L12.5161 0.837545ZM1.51146 4.66524C1.45379 4.68046 1.41946 4.73994 1.43512 4.79748L1.84679 6.30984C1.8627 6.36704 1.92234 6.401 1.97982 6.38584L2.58226 6.22694L3.07989 4.25155L1.51146 4.66524ZM3.57846 5.96418L5.19411 5.53804L5.69174 3.56265L4.0761 3.98879L3.57846 5.96418ZM6.19031 5.27528L7.78801 4.85387L8.28564 2.87848L6.68889 3.29964L6.19031 5.27528ZM11.363 3.91092L13.1194 3.44767C13.1767 3.43242 13.2103 3.37392 13.195 3.31662L12.7833 1.80427C12.7677 1.74679 12.7086 1.71199 12.651 1.72707L11.8606 1.93554L11.363 3.91092ZM8.78327 4.59136L10.3668 4.17368L10.8654 2.19805L9.28185 2.61572L8.78327 4.59136Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7954 7.7666C14.3033 7.81849 14.6996 8.24796 14.6997 8.76953V14.8945L14.6938 14.998C14.6455 15.4721 14.2694 15.849 13.7954 15.8975L13.6909 15.9033H2.15674L2.0542 15.8975C1.57974 15.8495 1.20215 15.4724 1.15381 14.998L1.14795 14.8945V8.76953C1.1481 8.24764 1.54585 7.81806 2.0542 7.7666L2.15674 7.76172H13.6909L13.7954 7.7666ZM2.04834 13.2656V14.8945C2.04849 14.9541 2.09718 15.0029 2.15674 15.0029H13.6909C13.7505 15.0029 13.7992 14.9541 13.7993 14.8945V13.2656H2.04834ZM2.15674 8.66211C2.09719 8.66211 2.0485 8.71002 2.04834 8.76953V12.3652H13.7993V8.76953C13.7992 8.71002 13.7505 8.66211 13.6909 8.66211H2.15674Z",
    fill: "#484848"
  }))), _symbol98 || (_symbol98 = /*#__PURE__*/React.createElement("symbol", {
    id: "location",
    viewBox: "0 0 13 18",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50002 0.851562C11.1614 0.85174 14.0371 5.97031 11.6313 9.98547L7.4961 16.8855C7.04387 17.6402 5.95521 17.6402 5.50298 16.8855L1.36879 9.98547C-1.03707 5.97024 1.8385 0.851562 6.50002 0.851562ZM6.50002 1.84742C2.60914 1.84742 0.20895 6.11954 2.2169 9.47101L6.35206 16.372C6.41938 16.484 6.58078 16.4842 6.64798 16.372L10.7831 9.47101C12.7908 6.11964 10.3907 1.8476 6.50002 1.84742Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51416 4.72461C7.45335 4.72471 8.21436 5.48546 8.21436 6.42285C8.2143 7.3602 7.45332 8.12099 6.51416 8.12109C5.57491 8.12109 4.81402 7.36026 4.81396 6.42285C4.81396 5.48539 5.57488 4.72461 6.51416 4.72461Z",
    stroke: "#484848"
  }))), _symbol99 || (_symbol99 = /*#__PURE__*/React.createElement("symbol", {
    id: "person",
    viewBox: "0 0 13 16",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 4.08203,
    r: 3,
    stroke: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.42188C9.81371 8.42188 12.5 11.1082 12.5 14.4219V14.5889C12.4998 15.0488 12.127 15.4217 11.667 15.4219H1.33301C0.873029 15.4217 0.500176 15.0488 0.5 14.5889V14.4219C0.5 11.1082 3.18629 8.42188 6.5 8.42188Z",
    stroke: "#484848"
  }))), _symbol100 || (_symbol100 = /*#__PURE__*/React.createElement("symbol", {
    id: "pencil-underline",
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 18.7578H9.87793H18.7559",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0973 3.79007L12.8874 1L17.77 5.88261L14.9799 8.67264M10.0973 3.79007L4.56675 9.32063C4.38176 9.50559 4.27783 9.75654 4.27783 10.0181V14.4921H8.75188C9.01349 14.4921 9.26434 14.3883 9.44939 14.2032L14.9799 8.67264M10.0973 3.79007L14.9799 8.67264",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol101 || (_symbol101 = /*#__PURE__*/React.createElement("symbol", {
    id: "x",
    viewBox: "0 0 22 22",
    fill: "none",
    stroke: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.63037 18.8906L18.8912 3.62982",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63037 3.63086L18.8912 18.8917",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))), _symbol102 || (_symbol102 = /*#__PURE__*/React.createElement("symbol", {
    id: "comment-stroke",
    viewBox: "0 0 18 16",
    fill: "current",
    stroke: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5H16C16.8284 0.5 17.5 1.17157 17.5 2V9.16797C17.5 9.9964 16.8284 10.668 16 10.668H5.2666C4.94224 10.668 4.67721 10.8025 4.48047 10.9434C4.38391 11.0125 4.29389 11.0906 4.21289 11.167L4 11.3799L1.35938 14.1094C1.04705 14.4318 0.500358 14.2109 0.5 13.7617V2C0.5 1.17157 1.17157 0.5 2 0.5Z",
    stroke: "current",
    strokeLinejoin: "round"
  }))), _symbol103 || (_symbol103 = /*#__PURE__*/React.createElement("symbol", {
    id: "like-stroke",
    viewBox: "0 0 17 16",
    fill: "current",
    stroke: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9004 0.864746C14.0787 0.864746 15.8008 2.60148 15.8008 4.86084C15.8007 6.24076 15.1959 7.53385 14.0352 8.98486C13.1602 10.0787 11.9976 11.2288 10.5977 12.5444L9.12109 13.9194H9.12012L8.6416 14.3647C8.4737 14.5209 8.22519 14.5404 8.03711 14.4233L7.95996 14.3647L7.48145 13.9194H7.48047C5.41082 12.0018 3.73298 10.4432 2.56641 8.98486C1.40569 7.53385 0.800834 6.24076 0.800781 4.86084C0.800781 2.60148 2.52283 0.864746 4.70117 0.864746C5.68995 0.864846 6.65585 1.24231 7.4043 1.87256L7.55078 2.00244C7.9445 2.36578 8.54975 2.38806 8.96973 2.06982L9.05078 2.00244C9.8173 1.29486 10.8457 0.864852 11.9004 0.864746Z",
    stroke: "current"
  }))), _symbol104 || (_symbol104 = /*#__PURE__*/React.createElement("symbol", {
    id: "scrap-stroke",
    viewBox: "0 0 13 17",
    fill: "current",
    stroke: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66089 1.1123H10.6609C11.4893 1.11231 12.1609 1.78388 12.1609 2.6123V14.4229C12.1609 14.8138 11.7323 15.0541 11.3992 14.8496L7.44702 12.418C6.96506 12.1215 6.35672 12.1215 5.87476 12.418L1.92261 14.8496C1.58952 15.0541 1.16089 14.8138 1.16089 14.4229V2.6123C1.16089 1.78388 1.83246 1.1123 2.66089 1.1123Z",
    stroke: "#AAD916"
  }))), _symbol105 || (_symbol105 = /*#__PURE__*/React.createElement("symbol", {
    id: "share",
    viewBox: "0 0 18 19",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9995 4L3.49951 9.5L13.9995 15.5",
    stroke: "#898989",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 3.5,
    r: 3.5,
    fill: "#AAD916"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 15.5,
    r: 3.5,
    fill: "#AAD916"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 9.5,
    r: 3.5,
    fill: "#AAD916"
  }))), _symbol106 || (_symbol106 = /*#__PURE__*/React.createElement("symbol", {
    id: "calendar-stroke",
    viewBox: "0 0 16 17",
    fill: "current",
    stroke: "current"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.52531,
    y: 3.19523,
    width: 13.4488,
    height: 12.3309,
    rx: 1.4175,
    stroke: "#484848",
    strokeWidth: 1.215
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58252 8.0293H14.9159",
    stroke: "#484848",
    strokeWidth: 1.215
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56104 1.58594V4.67893",
    stroke: "#484848",
    strokeWidth: 1.215,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9375 1.58594V4.67893",
    stroke: "#484848",
    strokeWidth: 1.215,
    strokeLinecap: "round"
  }))), _symbol107 || (_symbol107 = /*#__PURE__*/React.createElement("symbol", {
    id: "star-no-comment",
    viewBox: "0 0 220 183",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8458 45.1477C33.4305 28.2181 51.4896 17.7565 66.3941 25.7132L77.7738 31.7882C84.4796 35.3681 92.5204 35.3681 99.2262 31.7882L110.606 25.7132C125.51 17.7565 143.57 28.2181 144.154 45.1477L144.601 58.0736C144.864 65.6905 148.884 72.6776 155.327 76.7146L166.26 83.5655C180.58 92.5384 180.58 113.462 166.26 122.435L155.327 129.285C148.884 133.322 144.864 140.31 144.601 147.926L144.154 160.852C143.57 177.782 125.51 188.244 110.606 180.287L99.2262 174.212C92.5204 170.632 84.4796 170.632 77.7738 174.212L66.3941 180.287C51.4896 188.244 33.4305 177.782 32.8458 160.852L32.3993 147.926C32.1363 140.31 28.1158 133.322 21.6731 129.285L10.7399 122.435C-3.57996 113.462 -3.57995 92.5384 10.7399 83.5655L21.6732 76.7146C28.1158 72.6776 32.1363 65.6905 32.3993 58.0736L32.8458 45.1477Z",
    fill: "url(#paint0_radial_1929_9993)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.311 82.5H108.689C111.45 82.5 113.689 84.7386 113.689 87.5V109.34C113.689 110.691 113.143 111.984 112.174 112.925L96.2371 128.42C94.9693 129.652 92.843 128.754 92.843 126.986V116.452C92.843 113.691 90.6044 111.452 87.843 111.452H68.311C65.5496 111.452 63.311 109.214 63.311 106.452V87.5C63.311 84.7386 65.5496 82.5 68.311 82.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.388 2.00353C213.341 0.0509071 216.507 0.0509071 218.459 2.00353C220.412 3.95615 220.412 7.12197 218.459 9.0746L204.533 23.001L218.459 36.9274C220.412 38.88 220.412 42.0458 218.459 43.9984C216.507 45.951 213.341 45.951 211.388 43.9984L197.462 30.072L183.536 43.9984C181.583 45.951 178.417 45.951 176.464 43.9984C174.512 42.0458 174.512 38.88 176.464 36.9274L190.391 23.001L176.464 9.0746C174.512 7.12197 174.512 3.95615 176.464 2.00353C178.417 0.0509071 181.583 0.0509071 183.536 2.00353L197.462 15.9299L211.388 2.00353Z",
    fill: "url(#paint1_radial_1929_9993)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1929_9993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.777 117.207) rotate(92.571) scale(191.305 213.148)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29142,
    stopColor: "#C5D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82B5FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1929_9993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.969 26.9901) rotate(92.3244) scale(53.7037 54.1084)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29142,
    stopColor: "#C5D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82B5FF"
  }))))), _symbol108 || (_symbol108 = /*#__PURE__*/React.createElement("symbol", {
    id: "star-no-post",
    viewBox: "0 0 220 183",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8458 45.1477C33.4305 28.2181 51.4896 17.7565 66.3941 25.7132L77.7738 31.7882C84.4796 35.3681 92.5204 35.3681 99.2262 31.7882L110.606 25.7132C125.51 17.7565 143.57 28.2181 144.154 45.1477L144.601 58.0736C144.864 65.6905 148.884 72.6776 155.327 76.7146L166.26 83.5655C180.58 92.5384 180.58 113.462 166.26 122.435L155.327 129.285C148.884 133.322 144.864 140.31 144.601 147.926L144.154 160.852C143.57 177.782 125.51 188.244 110.606 180.287L99.2262 174.212C92.5204 170.632 84.4796 170.632 77.7738 174.212L66.3941 180.287C51.4896 188.244 33.4305 177.782 32.8458 160.852L32.3993 147.926C32.1363 140.31 28.1158 133.322 21.6731 129.285L10.7399 122.435C-3.57996 113.462 -3.57995 92.5384 10.7399 83.5655L21.6732 76.7146C28.1158 72.6776 32.1363 65.6905 32.3993 58.0736L32.8458 45.1477Z",
    fill: "url(#paint0_radial_1929_9992)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5 87H114.5",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.388 2.00353C213.341 0.050907 216.507 0.050907 218.459 2.00353C220.412 3.95615 220.412 7.12197 218.459 9.0746L204.533 23.001L218.459 36.9274C220.412 38.88 220.412 42.0458 218.459 43.9984C216.507 45.951 213.341 45.951 211.388 43.9984L197.462 30.072L183.536 43.9984C181.583 45.951 178.417 45.951 176.464 43.9984C174.512 42.0458 174.512 38.88 176.464 36.9274L190.391 23.001L176.464 9.0746C174.512 7.12197 174.512 3.95615 176.464 2.00353C178.417 0.050907 181.583 0.050907 183.536 2.00353L197.462 15.9299L211.388 2.00353Z",
    fill: "url(#paint1_radial_1929_9992)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5 103H114.5",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5 119H114.5",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1929_9992",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.777 117.207) rotate(92.571) scale(191.305 213.148)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29142,
    stopColor: "#C5D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82B5FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1929_9992",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.969 26.9901) rotate(92.3244) scale(53.7037 54.1084)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29142,
    stopColor: "#C5D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82B5FF"
  }))))), _symbol109 || (_symbol109 = /*#__PURE__*/React.createElement("symbol", {
    id: "star-no-review",
    viewBox: "0 0 220 183",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8458 45.1477C33.4305 28.2181 51.4896 17.7565 66.3941 25.7132L77.7738 31.7882C84.4796 35.3681 92.5204 35.3681 99.2262 31.7882L110.606 25.7132C125.51 17.7565 143.57 28.2181 144.154 45.1477L144.601 58.0736C144.864 65.6905 148.884 72.6776 155.327 76.7146L166.26 83.5655C180.58 92.5384 180.58 113.462 166.26 122.435L155.327 129.285C148.884 133.322 144.864 140.31 144.601 147.926L144.154 160.852C143.57 177.782 125.51 188.244 110.606 180.287L99.2262 174.212C92.5204 170.632 84.4796 170.632 77.7738 174.212L66.3941 180.287C51.4896 188.244 33.4305 177.782 32.8458 160.852L32.3993 147.926C32.1363 140.31 28.1158 133.322 21.6731 129.285L10.7399 122.435C-3.57996 113.462 -3.57995 92.5384 10.7399 83.5655L21.6732 76.7146C28.1158 72.6776 32.1363 65.6905 32.3993 58.0736L32.8458 45.1477Z",
    fill: "url(#paint0_radial_1924_9854)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.388 2.00353C213.341 0.050907 216.507 0.050907 218.459 2.00353C220.412 3.95615 220.412 7.12197 218.459 9.0746L204.533 23.001L218.459 36.9274C220.412 38.88 220.412 42.0458 218.459 43.9984C216.507 45.951 213.341 45.951 211.388 43.9984L197.462 30.072L183.536 43.9984C181.583 45.951 178.417 45.951 176.464 43.9984C174.512 42.0458 174.512 38.88 176.464 36.9274L190.391 23.001L176.464 9.0746C174.512 7.12197 174.512 3.95615 176.464 2.00353C178.417 0.050907 181.583 0.050907 183.536 2.00353L197.462 15.9299L211.388 2.00353Z",
    fill: "url(#paint1_radial_1924_9854)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.0991,
    height: 41.8318,
    rx: 3,
    transform: "matrix(-0.707107 -0.707107 0.701633 -0.712539 82.4722 126.602)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.0991,
    height: 8.36635,
    rx: 3,
    transform: "matrix(-0.707107 -0.707107 0.701633 -0.712539 116.112 92.7793)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5765 126.005C65.3449 125.98 65.1614 125.797 65.1348 125.564L63.8178 114.028C63.764 113.556 64.3292 113.28 64.6634 113.614L77.4374 126.388C77.7716 126.722 77.5016 127.294 77.0335 127.243L65.5765 126.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1924_9854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.777 117.207) rotate(92.571) scale(191.305 213.148)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29142,
    stopColor: "#C5D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82B5FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1924_9854",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.969 26.9901) rotate(92.3244) scale(53.7037 54.1084)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29142,
    stopColor: "#C5D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82B5FF"
  }))))), _symbol110 || (_symbol110 = /*#__PURE__*/React.createElement("symbol", {
    id: "google-form",
    viewBox: "0 0 17 16",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.11397 13.1852L14.4779 6.82127C15.3566 5.94261 15.3565 4.51797 14.4779 3.63929L13.2902 2.45157C12.4115 1.57289 10.9869 1.57289 10.1082 2.45157L5.48718 7.07262C5.16117 7.3987 5.00203 7.68008 4.95961 7.88331C4.92913 8.02951 4.9433 8.18175 5.14812 8.38671C5.39433 8.63292 5.81579 8.84279 6.25436 8.90737C6.70181 8.97324 6.99816 8.8704 7.14169 8.72714L11.5701 4.29875C11.863 4.00605 12.3379 4.00592 12.6307 4.29875C12.9234 4.59159 12.9234 5.06655 12.6307 5.35941L8.20235 9.7878C7.59607 10.3938 6.73985 10.4951 6.03546 10.3913C5.32179 10.2862 4.59092 9.95082 4.08746 9.44737C3.54314 8.90288 3.35172 8.24253 3.49084 7.57602C3.61817 6.96671 4.00323 6.43532 4.42652 6.01196L9.04757 1.39091C10.512 -0.073558 12.8864 -0.0735577 14.3509 1.39091L15.5386 2.57863C17.003 4.0431 17.003 6.41749 15.5386 7.88193L9.17463 14.2459C7.71018 15.7103 5.3358 15.7103 3.87133 14.2459L0.562287 10.9368C0.269394 10.644 0.269394 10.1691 0.562287 9.87619C0.85518 9.5833 1.33005 9.5833 1.62295 9.87619L4.93199 13.1852C5.81067 14.0638 7.23531 14.0639 8.11397 13.1852Z",
    fill: "#898989"
  }))), _symbol111 || (_symbol111 = /*#__PURE__*/React.createElement("symbol", {
    id: "active-check-circle",
    viewBox: "0 0 22 22",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.8613L9.31526 15.8L16.7 7",
    stroke: "#D9D9D9",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol112 || (_symbol112 = /*#__PURE__*/React.createElement("symbol", {
    id: "inactive-check-circle",
    viewBox: "0 0 22 22",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.8613L9.31526 15.8L16.7 7",
    stroke: "#5F86BF",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol113 || (_symbol113 = /*#__PURE__*/React.createElement("symbol", {
    id: "info-circle",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "#5F86BF",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18105 14.8294V8.14741H10.8191V14.8294H9.18105ZM8.20605 14.8294V14.0754C8.20605 13.9541 8.23639 13.8631 8.29705 13.8024C8.36639 13.7417 8.46172 13.6984 8.58305 13.6724L9.32405 13.5164L9.49305 14.8294H8.20605ZM10.5071 14.8294L10.6761 13.5164L11.4171 13.6724C11.5384 13.6984 11.6294 13.7417 11.6901 13.8024C11.7594 13.8631 11.7941 13.9541 11.7941 14.0754V14.8294H10.5071ZM9.49305 8.14741L9.32405 9.46041L8.58305 9.30441C8.46172 9.27841 8.36639 9.23508 8.29705 9.17441C8.23639 9.11374 8.20605 9.02274 8.20605 8.90141V8.14741H9.49305ZM10.0261 7.22441C9.74872 7.22441 9.50605 7.12474 9.29805 6.92541C9.09005 6.72608 8.98605 6.48774 8.98605 6.21041C8.98605 5.92441 9.09005 5.68174 9.29805 5.48241C9.50605 5.27441 9.74872 5.17041 10.0261 5.17041C10.3121 5.17041 10.5591 5.27441 10.7671 5.48241C10.9751 5.68174 11.0791 5.92441 11.0791 6.21041C11.0791 6.48774 10.9751 6.72608 10.7671 6.92541C10.5591 7.12474 10.3121 7.22441 10.0261 7.22441Z",
    fill: "white"
  }))), _symbol114 || (_symbol114 = /*#__PURE__*/React.createElement("symbol", {
    id: "active-check-circle-outline",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.94897,
    r: 7.5,
    fill: "#AAD916",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9.31454L7.38454 12L12 6",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol115 || (_symbol115 = /*#__PURE__*/React.createElement("symbol", {
    id: "info-triangle",
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.69043 2.15332C10.2629 1.12896 11.7371 1.12896 12.3096 2.15332L20.6055 16.998C21.1639 17.9978 20.441 19.2293 19.2959 19.2295H2.7041C1.55897 19.2293 0.836087 17.9978 1.39453 16.998L9.69043 2.15332Z",
    fill: "#FF849A",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.281 13.1842L10.008 7.86718L9.943 6.06018H11.867L11.802 7.86718L11.529 13.1842H10.281ZM9.969 16.1222V14.2762H11.867V16.1222H9.969Z",
    fill: "white"
  }))), _symbol116 || (_symbol116 = /*#__PURE__*/React.createElement("symbol", {
    id: "image",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 4.8,
    stroke: "#5F86BF",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 17.3553L8.5452 13.4929C9.79378 12.2495 11.8127 12.2494 13.0613 13.4929L13.7832 14.2118C15.0318 15.4552 17.0507 15.4552 18.2993 14.2118L19.3337 13.1817",
    stroke: "#5F86BF",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.3838,
    cy: 7.49175,
    r: 1.22222,
    fill: "#5F86BF",
    stroke: "#5F86BF"
  }))), _symbol117 || (_symbol117 = /*#__PURE__*/React.createElement("symbol", {
    id: "image-fill",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 4.8,
    fill: "#5F86BF",
    stroke: "#5F86BF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 17.3553L8.5452 13.4929C9.79378 12.2495 11.8127 12.2494 13.0613 13.4929L13.7832 14.2118C15.0318 15.4552 17.0507 15.4552 18.2993 14.2118L19.3337 13.1817",
    stroke: "#EAF5FD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.3838,
    cy: 7.49175,
    r: 1.22222,
    fill: "#EAF5FD",
    stroke: "#EAF5FD"
  }))), _symbol118 || (_symbol118 = /*#__PURE__*/React.createElement("symbol", {
    id: "video",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "#5F86BF",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3887 11.1342C16.0553 11.5191 16.0553 12.4813 15.3887 12.8662L11.0553 15.3681C10.3887 15.753 9.55534 15.2719 9.55534 14.5021L9.55534 9.49837C9.55534 8.72857 10.3887 8.24744 11.0553 8.63234L15.3887 11.1342Z",
    stroke: "#5F86BF",
    strokeWidth: 1.8
  }))), _symbol119 || (_symbol119 = /*#__PURE__*/React.createElement("symbol", {
    id: "video-opaque",
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.1599,
    cy: 19.4116,
    r: 18.48,
    fill: "#EAF5FD",
    fillOpacity: 0.5,
    stroke: "#EAF5FD",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8533 17.9576C26.9733 18.6043 26.9733 20.2208 25.8533 20.8675L18.5733 25.0706C17.4533 25.7172 16.0533 24.9089 16.0533 23.6157L16.0533 15.2094C16.0533 13.9162 17.4533 13.1079 18.5733 13.7545L25.8533 17.9576Z",
    fill: "#EAF5FD"
  }))), _symbol120 || (_symbol120 = /*#__PURE__*/React.createElement("symbol", {
    id: "video-fill",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#5F86BF",
    stroke: "#5F86BF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3889 11.1342C16.0556 11.5191 16.0556 12.4813 15.3889 12.8662L11.0556 15.3681C10.3889 15.753 9.55558 15.2719 9.55558 14.5021L9.55558 9.49837C9.55558 8.72857 10.3889 8.24744 11.0556 8.63234L15.3889 11.1342Z",
    fill: "#EAF5FD",
    stroke: "#EAF5FD"
  }))), _symbol121 || (_symbol121 = /*#__PURE__*/React.createElement("symbol", {
    id: "image-select-bar",
    viewBox: "0 0 31 96",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H18.5C25.1274 0 30.5 5.37258 30.5 12V84C30.5 90.6274 25.1274 96 18.5 96H0.5V0Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.1587,
    cy: 41,
    r: 2,
    fill: "#BFD7EC",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8413,
    cy: 41,
    r: 2,
    fill: "#BFD7EC",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.1587,
    cy: 48,
    r: 2,
    fill: "#BFD7EC",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8413,
    cy: 48,
    r: 2,
    fill: "#BFD7EC",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.1587,
    cy: 55,
    r: 2,
    fill: "#BFD7EC",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8413,
    cy: 55,
    r: 2,
    fill: "#BFD7EC",
    stroke: "none"
  }))), _symbol122 || (_symbol122 = /*#__PURE__*/React.createElement("symbol", {
    id: "trashcan",
    viewBox: "0 0 101 100",
    fill: "none",
    stroke: "white"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4991_10310)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4991_10310)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50,
    r: 45,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.4043,
    y: 45.5117,
    width: 18.1915,
    height: 16.456,
    rx: 1.5,
    fill: "#FF849A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7742 38.7792C52.7742 38.3661 52.4393 38.0312 52.0262 38.0312H48.9743C48.5612 38.0312 48.2263 38.3661 48.2263 38.7792C48.2263 39.1924 47.8914 39.5272 47.4783 39.5272H42.9003C42.0741 39.5272 41.4043 40.197 41.4043 41.0232C41.4043 41.8495 42.0741 42.5192 42.9003 42.5192H58.0998C58.926 42.5192 59.5958 41.8495 59.5958 41.0232C59.5958 40.197 58.926 39.5272 58.0998 39.5272H53.5222C53.1091 39.5272 52.7742 39.1924 52.7742 38.7792Z",
    fill: "#FF849A"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4991_10310",
    x: -12.5,
    y: -13,
    width: 126,
    height: 126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.921569 0 0 0 0 0.964706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4991_10310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4991_10310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4991_10310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "download",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3V16M12 16L6 10.3478M12 16L18 10.3478",
    stroke: "black",
    strokeWidth: 1.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V17",
    stroke: "black",
    strokeWidth: 1.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol123 || (_symbol123 = /*#__PURE__*/React.createElement("symbol", {
    id: "open-editor",
    viewBox: "0 0 26 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6709 12.6387L14.3633 12.6387",
    stroke: "var(--blue-3)",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7344 2.55859L25.0191 2.55859",
    stroke: "var(--blue-3)",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8135 9.42383L25.0195 9.42383",
    stroke: "var(--blue-3)",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0488 16.3926L25.0195 16.3926",
    stroke: "var(--blue-3)",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16211 0.972656L0.828775 18.6503",
    stroke: "var(--blue-3)",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16211 0.966797L17.4954 18.6445",
    stroke: "var(--blue-3)",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }))), _symbol124 || (_symbol124 = /*#__PURE__*/React.createElement("symbol", {
    id: "open-editor-fill",
    viewBox: "0 0 27 21",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.04102 13.0664L14.7334 13.0664",
    stroke: "var(--blue-3)",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1045 2.98633L25.3892 2.98633",
    stroke: "var(--blue-3)",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1826 9.85156L25.3887 9.85156",
    stroke: "var(--blue-3)",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.418 16.8203L25.3887 16.8203",
    stroke: "var(--blue-3)",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53125 1.40039L1.19792 19.0781",
    stroke: "var(--blue-3)",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53125 1.39453L17.8646 19.0722",
    stroke: "var(--blue-3)",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol125 || (_symbol125 = /*#__PURE__*/React.createElement("symbol", {
    id: "font-color",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 3H19",
    stroke: "#898989",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3L10 21",
    stroke: "#898989",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 14,
    width: 7,
    height: 7,
    fill: "currentColor",
    stroke: "none"
  }))), _symbol126 || (_symbol126 = /*#__PURE__*/React.createElement("symbol", {
    id: "bg-color",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "var(--bg-icon-fill, #E6F7B1)",
    stroke: "var(--bg-icon-stroke, #AAD916)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44043 3.43945H21.132",
    stroke: "#898989",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2861 3.43945L12.2861 21.131",
    stroke: "#898989",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }))), _symbol127 || (_symbol127 = /*#__PURE__*/React.createElement("symbol", {
    id: "bold",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.01758 3L6.01758 21",
    stroke: "var(--icon-stroke, #898989)",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3H13.1506C15.389 3 17.2036 4.81458 17.2036 7.05298C17.2036 9.29138 15.389 11.106 13.1506 11.106H6",
    stroke: "var(--icon-stroke, #898989)",
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 11.1055H13.2722C16.0044 11.1055 18.2192 13.3203 18.2192 16.0525C18.2192 18.7847 16.0044 20.9995 13.2722 20.9995H6",
    stroke: "var(--icon-stroke, #898989)",
    strokeWidth: 2.6
  }))), _symbol128 || (_symbol128 = /*#__PURE__*/React.createElement("symbol", {
    id: "underline",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 21L2 21",
    stroke: "var(--icon-stroke, #484848)",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3L7 11C7 13.7614 9.23858 16 12 16C14.7614 16 17 13.7614 17 11L17 3",
    stroke: "var(--icon-stroke, #898989)",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }))), _symbol129 || (_symbol129 = /*#__PURE__*/React.createElement("symbol", {
    id: "strikethrough",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3H21",
    stroke: "var(--icon-stroke, #898989)",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3L12 21",
    stroke: "var(--icon-stroke, #898989)",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 11L2 11",
    stroke: "var(--icon-stroke, #484848)",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }))), _symbol130 || (_symbol130 = /*#__PURE__*/React.createElement("symbol", {
    id: "no-color",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12.5,
    fill: "#EAF5FD",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 7L7 21",
    stroke: "#FF4B6C",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12.5,
    stroke: "white",
    strokeWidth: 3
  }))), _symbol131 || (_symbol131 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-editor",
    viewBox: "0 0 12 10",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.773438 5.19283L4.24186 8.77344L10.9553 0.773438",
    stroke: "currentColor",
    strokeWidth: 1.54545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.c4e947601f370f1139eccba11fa7a9f4.svg";
export { ForwardRef as ReactComponent };